import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mode-forecast-top-toolbar" }
const _hoisted_2 = { class: "mode-forecast-element-toolbar" }
const _hoisted_3 = { class: "mode-forecast-element-group" }
const _hoisted_4 = { class: "mode-forecast-element-group-items" }
const _hoisted_5 = {
  key: 0,
  class: "mode-forecast-element-item"
}
const _hoisted_6 = { class: "mode-forecast-element-item-title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "mode-forecast-element-item mode-forecast-element-item-single"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mode-compare-control-panel" }
const _hoisted_11 = { class: "mode-compare-control-panel-box" }
const _hoisted_12 = { class: "mode-forecast-mode-card mode-forecast-mode-card-inside-panel" }
const _hoisted_13 = { class: "mode-forecast-mode-card-title" }
const _hoisted_14 = { class: "mode-forecast-mode-card-options mode-forecast-mode-card-options-row" }
const _hoisted_15 = ["onClick", "title"]
const _hoisted_16 = { class: "mode-compare-control-panel-date-title" }
const _hoisted_17 = { class: "mode-compare-control-panel-box-main" }
const _hoisted_18 = { class: "mode-compare-control-panel-box-main-left" }
const _hoisted_19 = { class: "mode-compare-control-panel-option-box" }
const _hoisted_20 = { class: "mode-compare-control-panel-merge" }
const _hoisted_21 = { class: "mode-compare-control-panel-merge" }
const _hoisted_22 = { class: "mode-compare-control-panel-merge" }
const _hoisted_23 = { class: "mode-compare-control-panel-option-box" }
const _hoisted_24 = { class: "mode-compare-control-panel-height-select-box" }
const _hoisted_25 = { class: "mode-compare-control-panel-height-select-half-box" }
const _hoisted_26 = { class: "mode-compare-control-panel-select-title" }
const _hoisted_27 = { class: "mode-compare-control-panel-select-box" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "mode-compare-control-panel-placeholder"
}
const _hoisted_30 = { class: "mode-compare-control-panel-height-select-half-box" }
const _hoisted_31 = { class: "mode-compare-control-panel-select-title" }
const _hoisted_32 = { class: "mode-compare-control-panel-select-box" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "mode-compare-control-panel-placeholder"
}
const _hoisted_35 = {
  class: "mode-compare-control-panel-option-box",
  style: {"flex":"auto","height":"0"}
}
const _hoisted_36 = { class: "mode-compare-control-panel-select-title" }
const _hoisted_37 = { class: "mode-compare-control-panel-select-title" }
const _hoisted_38 = { class: "mode-compare-control-panel-select-box" }
const _hoisted_39 = {
  key: 0,
  class: "mode-compare-control-panel-total-date-box"
}
const _hoisted_40 = { class: "mode-compare-control-panel-total-date-list" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "mode-compare-control-panel-total-date-list" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "single-draw-info-text" }
const _hoisted_46 = { class: "single-draw-info-text" }
const _hoisted_47 = { class: "height-box" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "single-draw-info-text" }

import { computed, ref, onMounted, onUnmounted, reactive, watch } from "vue";
import { $Bus } from "erayic-com-pack/EventBus";
import { Enum_ForecastElement, Enum_ForecastMode } from "erayic-com-pack/utils/attribute/Element";
import { $Self } from "../../../EventsBus";
import { ElMessage } from "element-plus";
import ModeCompare from "../../../components/ModeCompare/ModeCompare.vue";
import * as ModeForecast from "./ModeForecast";
import * as Available from "./Available";
import Container from "erayic-com-pack/component/Container/Container.vue";
import { GrayScaleImage } from "erayic-com-pack/encapsulation/GrayscaleImage/GrayscaleImage";
import { DateAdd, timeToString } from "erayic-com-pack/utils/timerToString";
import { ModeCompareEvents } from "@/EventsBus/Apply/ModeCompareEvents";
import { getGPHGeojsonRes, getGeopotentialHeightLayer } from "erayic-com-pack/encapsulation/layers/GeopotentialHeightLayer";
import { ModeForecastAPI } from "./ModeForecast.api";
import ECMWFImagePanel from 'erayic-com-pack/component/ECMWFImagePanel/ECMWFImagePanel.vue'; //ECMWF
import * as ModeForecastType from "./ModeForecast.type";
import Layer, { DrawLayerType } from "erayic-com-pack/component/NewMap/NewMapLayer/Layer";
import { RenderLayerLevel } from "erayic-com-pack/component/NewMap/NewMapBean";
import { Enum_DrawType, Enum_MapToolsPanelType, Enum_MapWorkMode, Enum_ScreenScaptureType } from "erayic-com-pack/utils/enum";
import { Fy3LrcDataTextureGridImage } from "@/GridImage/order/Fy3LrcDataTextureGridImage";
import { Enum__Fy3IrcTextureSatelliteType, Enum__Fy3IrcTextureSensorElement, Enum__Fy3IrcUserApiType } from "@/GridImage/order/bean";
import { Enum_NewPlotOperaateType, EnumChooseOperates } from "erayic-com-pack/component/NewPlotTools/bean";
import { MapStore } from "@/store/map";
import { drawOption } from "./ModeForecast";
import { Enum_ScreenCaptureBorderFormType, I_SetScreenCaptureModeColorBarItem, ScreenCaptureEvents } from "erayic-com-pack/EventBus/Apply/ScreenCaptuer";
import { Api_GetUparWprByLatLonRange } from "../FactsMonitor/components/WindProfileRadarPanel/Api";
import { Contour, smoothLines, isolines } from 'wcontour-js';
import { interp } from "erayic-com-pack/component/NewMap/NewMapLayer/NewAutoStationLayer";
import { Lists_Type } from "../FactsMonitor/components/WindProfileRadarPanel/bean";
import { getWindSpeedImgPath } from "erayic-com-pack/utils/queryChar";
import HighLevelSlicePanel from "erayic-com-pack/component/HighLevelSlicePanel/HighLevelSlicePanel.vue";
import { Enum_Environment } from "@/views/Main/MainBean";
import NewMap from "erayic-com-pack/component/NewMap/NewMap.vue";
import { EnvironmentStore } from '@/store/Environment';
import { useI18n } from 'vue-i18n'
import { translate } from '@/i18n/i18nHelper';
import { useRoute } from 'vue-router';
import { SpecificWindColor } from "erayic-com-pack/encapsulation/composables/useColorMap";



/** 模式对比Ref */

export default /*@__PURE__*/_defineComponent({
  __name: 'ModeForecast',
  setup(__props) {

const ModeCompareRef = ref();
/** 模式选择数组 */
const modeSelectList = ref<(Enum_ForecastMode)[]>([Enum_ForecastMode.SPCC]);
const subjectiveModeOptions = computed(() => ModeForecast.ModeList[ModeForecast.Enum_ModeType.模式].filter((item) => item.key === Enum_ForecastMode.SPCC));
/** 展示选择项 */
const displaySelect = ref<"single" | "compare" | "adjust" | "multiTime" | "multiElement" | "difference">("single");
/** 当前要素类别绑定变量 */
const currentElementCategory = ref<string>("形势场");
/** 要素绑定变量 */
const selectElement = ref<Enum_ForecastElement>();

/** 位势高度选中模式 */
const heightSelectMode = ref<Enum_ForecastMode>();
/** 位势高度场层次绑定变量 */
const heightSelectLevel = ref<number | undefined>(500);
/** 海平面气压绑定项 */
const seaLevelPressure = ref<boolean>(false);
/** 位势高度geojson存储 */
const GPHGeojson = ref<{ origin?: GeoJSON.FeatureCollection<GeoJSON.LineString, GeoJSON.GeoJsonProperties>, clip?: GeoJSON.FeatureCollection }>({});
/** 海平面气压geojson存储 */
const seaLevelPressureGeojson = ref<{ origin?: GeoJSON.FeatureCollection<GeoJSON.LineString, GeoJSON.GeoJsonProperties>, clip?: GeoJSON.FeatureCollection }>({});

/** 风场选中模式 */
const windSelectMode = ref<Enum_ForecastMode>();
/** 风场层次绑定变量 */
const windSelectLevel = ref<number | undefined>(0);

const windyColorElements = new Set<Enum_ForecastElement>([
  Enum_ForecastElement.UV,
  Enum_ForecastElement.WS12,
  Enum_ForecastElement.GUST
]);

const getSpecifiedColorCode = (element?: Enum_ForecastElement) => {
  if (!element || !windyColorElements.has(element)) return undefined;
  return SpecificWindColor;
};

const currentWindLevelOption = computed(() => {
  const currentMode = modeSelectList.value[0];
  const currentModeAvailableElement = Available.AvailableElement[currentMode] ?? [];
  const supportGroundWind = currentModeAvailableElement.includes(Enum_ForecastElement.UV);
  const supportHeightWind = currentModeAvailableElement.includes(Enum_ForecastElement.L_WIUV);

  if (supportGroundWind && !supportHeightWind) return [0];
  if (!supportGroundWind && supportHeightWind) return ModeForecast.windLevelOption.filter((item) => item !== 0);
  return ModeForecast.windLevelOption;
});

const windSelectTitle = computed(() => currentWindLevelOption.value.length === 1 && currentWindLevelOption.value[0] === 0
  ? `10m${t('wind')}`
  : t('WIUV'));

/** 格点风场绑定项 */
const gridWind = ref<boolean>(true);
/** 格点数据绑定项 */
const gridData = ref<boolean>(false);
/** 渐变填色 */
const linearFillColor = ref(false);
/** 遮罩显示 */
const maskDisplay = ref(false);
/** 流线显示 */
const flowLineDisplay = ref(true);
/** 等值线显示 */
const isolineDisplay = ref(false);

/** 预报时效间隔绑定变量 */
const forecastDateInterval = ref<number>(24);
/** 预报时效间隔选项 */
const forecastDateIntervalOption = ref<number[]>();
/** 预报时效绑定变量 */
const forecastDateScale = ref<number>(1);
/** 累计要素预报时效绑定变量 */
const totalForecastDateScale = ref<[number, number]>([0, 24]);
/** 预报时效选项 */
const forecastDateScaleOption = ref<number[]>([]);
/** 预报时效选项滚动条绑定项 */
const fcstOptionScrollBarRef = ref();
/** 预报时间长度 */
const multiTimeLength = ref<3 | 4 | 6>(4);
/** 起报时间列表 */
const dataDateList = ref<string[]>([]);
/** 当前起报时间 */
const currentDataDate = ref<string>("");
/** 前起报时间 */
const lastDataDate = ref<string>("");
/** 预报调整的起报时间数组 */
const currentAdjustDataDateList = ref<string[]>([]);
/** 分时展示的预报时效数组 */
const multiTimeForecastDateScaleList = ref<number[]>([]);

/** 多要素选中要素列表 */
const selectElementList = ref<Enum_ForecastElement[]>([]);

/** 面板分页项 */
const panelPage = ref<0 | 1>(0);
/** 图库 */
const isGallery = ref(false);
/** 垂直廓线 */
const verticalProfile = ref(false);
/** 单点多模式 */
const singleMultiMode = ref(false);
/** 琼州海峡 */
const qiongzhouStrait = ref(false);
/** 垂直剖面 */
const verticalSection = ref(false);
/** 高层切片 */
const highLevelSlice = ref(false);
/** 高层切片选定高度层 */
const highLevelSliceHeight = ref<number[]>([300, 400, 500, 600, 700, 850]);
/** 风云增强 */
const satellite = ref(false);
/** 风廓线雷达 */
const wpr = ref(false);
/** 风廓线雷达高度 */
const wprHeightIndex = ref<number>();
/** 风廓线雷达高度选项 h(米) gh(hPa) */
const wprHeightOption = [{ h: 110, gh: 1000 }, { h: 760, gh: 925 }, { h: 1460, gh: 850 }, { h: 3010, gh: 700 }, { h: 5570, gh: 500 }, { h: 11770, gh: 200 }];
/** 风廓线雷达图层 */
const WprLayer = ref<Layer>();
/** 风廓线雷达展示形式 */
const wprDisplayTag = ref<"grid" | "isoline">("grid");
/** 风廓线雷达数据时间 */
const wprDate = ref<string>();

/** 集合预报折叠绑定项 */
const isFoldEnsemble = ref<boolean>(true);

/** 当前正在绘制的切片图层 */
const sliceLayerInfo = ref<{ LayerId: string, resData: ModeForecastType.TexClipParams }>();
/** 当前绘制图层类型 */
const currentLayerTag = ref<"tex" | "isoline">("tex");
/** 高层切片图层可选择的高度 */
const sliceLayerHeightOption = ref<number[]>([]);
/** 高层切片图层当前绑定高度 */
const sliceLayerCurrentHeight = ref<number>();
/** 当前正在绘制的等值线图层信息 */
const currentModeJson = ref<{ url: string, layer: Layer, mode: Enum_ForecastMode, ele: Enum_ForecastElement, res: { dataTime: string[], timeSeries: { "-1": string[], [key: string]: string[] }, url: string } }>();

/** 模式对比  图层信息(包括风场/位势高度场)  多要素 仅使用图层信息(风场/位势高度场使用splitScreenWind/GeoHeightInfo) */
const splitScreenLayerInfo = ref<ModeForecastType.SplitScreenLayerInfo[]>([]);
/** 预报调整/分时展示/多要素  位势高度信息 */
const splitScreenGeoHeightInfo = ref<{ dataTime: string[], timeSeries: { "-1": string[], [key: string]: string[] }, url: string }>();
/** 预报调整/分时展示/多要素  海平面气压信息 */
const splitScreenSLPInfo = ref<{ dataTime: string[], timeSeries: { "-1": string[], [key: string]: string[] }, url: string }>();
/** 预报调整/分时展示/多要素  风场信息 */
const splitScreenWindInfo = ref<{ height?: ModeForecastType.TexClipParams, ground?: ModeForecastType.TexClipParams }>();

/** 二级菜单折叠状态管理 */
const foldStates = reactive(new Map<ModeForecastType.SecondMenuItem, boolean>());

// /** 绘制面板参数 */
// const drawParams = ref({ lineWidth: 4, fontSize: 16, fontColor: "#000", lineColor: "#000" });


const { t, locale } = useI18n();
const currentLanguage = ref('zh');
// 添加 route 和 router
const route = useRoute();



// 通过URL参数设置语言的函数
const initializeLanguageFromUrl = () => {
  // 从URL参数获取语言设置
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');

  // 如果URL中有语言参数且有效，则使用它；否则使用localStorage中保存的语言或默认中文
  if (langParam && ['en', 'zh'].includes(langParam)) {
    applyLanguageSettings(langParam);
  } else {
    const storedLang = localStorage.getItem('language');
    if (storedLang && ['en', 'zh'].includes(storedLang)) {
      applyLanguageSettings(storedLang);
      // 同步URL参数
      updateUrlLanguageParameter(storedLang);
    } else {
      applyLanguageSettings('zh');
    }
  }
};

// 应用语言设置（不更改URL）
const applyLanguageSettings = (lang: string) => {
  currentLanguage.value = lang;

  // 核心逻辑：操作 body 的 classList
  if (lang === 'en') {
    document.body.classList.add('en-mode');
    document.body.classList.remove('zh-mode');
  } else {
    document.body.classList.remove('en-mode');
    document.body.classList.add('zh-mode');
  }

  locale.value = lang;
  localStorage.setItem('language', lang);
};

// 更新URL中的语言参数
const updateUrlLanguageParameter = (lang: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lang);
  window.history.replaceState({}, '', url.toString());
};

// 切换语言的方法
const switchLanguage = (lang: string) => {
  // 应用语言设置
  applyLanguageSettings(lang);

  // 更新URL参数
  updateUrlLanguageParameter(lang);

  // 模式不支持要素情况下 更新叠加形势场/风场为新的模式
  refreshGeopotentialHeightAndAltitudeWind();
  ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: t('currentModeNotAvailable') + ModeForecast.getEleCHN(selectElement.value) });
  if (currentModeJson.value && currentModeJson.value.layer) {
    $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: currentModeJson.value.layer.layerID! });
    currentModeJson.value = undefined;
  }
};

// 初始化 foldStates
watch(() => ModeForecast.elementList.value, (newVal) => {
  newVal.forEach(category => {
    category.element.forEach(item => {
      if (ModeForecast.isSecondMenu(item) && item.isFold !== undefined) {
        if (!foldStates.has(item)) {
          foldStates.set(item, item.isFold);
        }
      }
    });
  });
}, { immediate: true });

onMounted(async () => {

  initializeLanguageFromUrl();


  const appElement = document.getElementById('app');
  if (appElement) {
    appElement.classList.add(`${currentLanguage.value}-mode`);
  }

  MapStore().MapTarget.on("load", async () => {
    ModeForecast.DrawBasicWordLayer();
  });

  $Self.ApplyEvents.ModeCompare.on("ChangeSpecifiedOpacity", (params) => {
    if (sliceLayerInfo.value) {
      $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, SpecifiedAlpha: params });
    }
  });

  // 键盘事件
  window.addEventListener('keydown', ModeForecastOnKeyDownHandle);

  // 默认选中SPCC整点平均10m风风速并初始化时序
  selectElementHandle(Enum_ForecastElement.UV);

  // 修改工作环境为ModeForecast
  const environmentStore = EnvironmentStore();
  environmentStore.Environment = Enum_Environment.ModeForecast;
  ModeForecast.changeMapboxLonLatInfoMationDomPosition(Enum_Environment.ModeForecast);

  // 监听Container关闭事件
  $Bus.BaseEvents.Panel.on("Close_SpecifyPanel", CloseSpecifyPanelHandle);
});

onUnmounted(() => {
  document.body.classList.remove('en-mode');
  document.body.classList.remove('zh-mode');
  ModeForecast.removeGeopotentialHeightAndAltitudeWind();
  if (displaySelect.value === "single") clearLayerInfoMarker();
  if (sliceLayerInfo.value) clearSliceLayer();
  window.removeEventListener('keydown', ModeForecastOnKeyDownHandle);
  $Self.ApplyEvents.ModeCompare.off("ChangeSpecifiedOpacity");
  $Bus.BaseEvents.Panel.off("Close_SpecifyPanel", CloseSpecifyPanelHandle);

  //   if (currentDrawMode.value) {
  //     $Bus.MapEvent.Plot.emit("ClearPlot", {});
  //     $Bus.MapEvent.Basic.emit("SetMapMode", { Mode: Enum_MapWorkMode.Browse });
  //   }

  if (highLevelSlice.value) {
    MapStore().MapTarget.dragRotate.disable();
    MapStore().MapTarget.setPitch(0);
    MapStore().MapTarget.rotateTo(0);
    $Bus.MapEvent.Texture.emit('RemoveHighLevelSlice');
    $Bus.MapEvent.Texture.emit('CloseHighLevelSlice');
  }

  if (singleMultiMode.value) {
    ModeForecast.switchSingleMultiMode(false);
    $Bus.ApplyEvents.OtherLayer.emit("MarkDotLayer");
  }
  if (satellite.value) satelliteClickHandle();
  if (wpr.value) {
    removeWprHeightLayer();
    $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "WPRInfoPanel" });
  }

  $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "ScreenCapturePanel" });
});

// 键盘按键响应事件
function ModeForecastOnKeyDownHandle(this: Window, ev: KeyboardEvent) {
  if (['ArrowUp', 'ArrowDown'].includes(ev.key) && forecastDateScaleOption.value) {
    const index = forecastDateScaleOption.value.findIndex((item) => item === forecastDateScale.value);

    // 当调整过预报时效间隔后  按照新预报时效间隔响应
    const intervalIndex = forecastDateInterval.value / forecastDateIntervalOption.value![0];
    ev.preventDefault();

    if (ev.key === 'ArrowUp' && index - intervalIndex >= 0) {
      changeDataDate(forecastDateScaleOption.value[index - intervalIndex], index - intervalIndex);
      fcstOptionScrollBarRef.value.setScrollTop(fcstOptionScrollBarRef.value.wrapRef.scrollTop - 25);
    }
    if (ev.key === 'ArrowDown' && index + intervalIndex < forecastDateScaleOption.value.length) {
      changeDataDate(forecastDateScaleOption.value[index + intervalIndex], index + intervalIndex);
      fcstOptionScrollBarRef.value.setScrollTop(fcstOptionScrollBarRef.value.wrapRef.scrollTop + 25);
    }
  }
};

// Container关闭事件处理
const CloseSpecifyPanelHandle = (params: { Source: string }) => {
  if (params.Source === "QiongZhouStraitPanel") qiongzhouStrait.value = false;
};

// /** 切换展示模式 */
// const changeDisplayHandle = async (display: "single" | "compare" | "adjust" | "multiTime" | "difference" | "multiElement") => {
//   // 进入地图视图以外的多分屏展示模式时的处理
//   if (display !== "single" && displaySelect.value === "single") {
//     $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "SingleDrawInfo" });
//     $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "SingleDrawTex" });
//     $Bus.BaseEvents.Panel.emit("ChangeBasePropData", { Source: "ModeSliceHeightPanel", Style: { position: "fixed", right: "344px", bottom: 0 } });

//     // 移除单屏绘制的图层
//     if (currentLayerTag.value === "isoline") {
//       if (currentModeJson.value && currentModeJson.value.layer) $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: currentModeJson.value.layer.layerID! });
//     } else if (sliceLayerInfo.value)
//       $Bus.MapEvent.Texture.emit("RemoveSliceTexture", { LayerId: sliceLayerInfo.value.LayerId });

//     // 退出高层切片
//     if (highLevelSlice.value) highLevelSliceClickHandle();
//   }

//   const lastDisplayTag = displaySelect.value;
//   displaySelect.value = display;
//   switch (display) {
//     case "single":
//       $Self.ApplyEvents.ModeCompare.emit("ExitSplitScreen"); // 退出多分屏
//       $Bus.BaseEvents.Panel.emit("ChangeBasePropData", { Source: "ModeSliceHeightPanel", Style: { position: "fixed", bottom: "34px", right: "315px" } });

//       if (modeSelectList.value.length) modeSelectList.value = modeSelectList.value.slice(0, 1);
//       else modeSelectList.value = [Enum_ForecastMode.ECTHIN];

//       // 重绘地图视图切片要素图
//       if (!selectElement.value) selectElement.value = Enum_ForecastElement.PRE24;
//       const eleInfo = ModeForecast.getElementInfo(selectElement.value);
//       selectElementHandle(selectElement.value, eleInfo?.isIsoline, true, true);

//       $Bus.BaseEvents.Panel.emit("Open_SpecifyPanel", { Source: "SingleDrawInfo" });
//       $Bus.BaseEvents.Panel.emit("Open_SpecifyPanel", { Source: "SingleDrawTex" });
//       break;
//     case "compare":
//       if (!selectElement.value) selectElement.value = Enum_ForecastElement.PRE24;
//       modeSelectList.value = [];
//       for (let key in Available.AvailableElement)
//         if (Available.AvailableElement[key as Enum_ForecastMode]?.includes(selectElement.value!)) {
//           modeSelectList.value.push(key as Enum_ForecastMode);
//           if (modeSelectList.value.length === 4) break;
//         }
//       generateCompareModeByElement();
//       break;
//     case "adjust":
//       if (lastDisplayTag === "compare" && sliceLayerInfo.value) {
//         sliceLayerInfo.value.resData = splitScreenLayerInfo.value[0].texResData;
//         handleDateInfo(sliceLayerInfo.value.resData.dataTime, sliceLayerInfo.value.resData.timeSeries);
//       }

//       if (modeSelectList.value.length) modeSelectList.value = modeSelectList.value.slice(0, 1);
//       else modeSelectList.value = [Enum_ForecastMode.ECTHIN];

//       if (!sliceLayerInfo.value) return selectElementHandle(Enum_ForecastElement.PRE24);

//       // 确保起报时可用
//       currentAdjustDataDateList.value = [dataDateList.value[dataDateList.value.length - 1]];
//       const fcstDate = DateAdd("h", forecastDateScale.value, currentAdjustDataDateList.value[0]);
//       for (let i = dataDateList.value.length - 2; i >= 0; i--) {
//         const hour = (fcstDate.getTime() - new Date(dataDateList.value[i]).getTime()) / (1000 * 60 * 60);
//         const hourString = timeToString(new Date(currentDataDate.value), "HH");
//         const fcstTimeLength = sliceLayerInfo.value?.resData.timeSeries[hourString] ?? sliceLayerInfo.value?.resData.timeSeries["-1"];
//         if (fcstTimeLength.includes(hour.toString())) {
//           currentAdjustDataDateList.value.push(dataDateList.value[i]);
//           if (currentAdjustDataDateList.value.length === 4) break;
//         }
//       }
//       generateAdjustSplitScreenParams();

//       // 从single或compare切换到该展示模式时 填充位势高度场/风场信息
//       if (lastDisplayTag === "single") {
//         splitScreenGeoHeightInfo.value = getGPHGeojsonRes().L_GPH;
//         splitScreenSLPInfo.value = getGPHGeojsonRes().SLP;
//         splitScreenWindInfo.value = { height: ModeForecast.getWindTexClipParams()?.height?.resData, ground: ModeForecast.getWindTexClipParams()?.ground?.resData };
//       }
//       else if (lastDisplayTag === "compare") {
//         splitScreenGeoHeightInfo.value = splitScreenLayerInfo.value[0].height;
//         splitScreenSLPInfo.value = splitScreenLayerInfo.value[0].slp;
//         splitScreenWindInfo.value = splitScreenLayerInfo.value[0].wind;
//       }

//       refreshSplitScreenGeoHeightAndWind();
//       break;
//     case "multiTime":
//       if (lastDisplayTag === "compare" && sliceLayerInfo.value) {
//         sliceLayerInfo.value.resData = splitScreenLayerInfo.value[0].texResData;
//         handleDateInfo(sliceLayerInfo.value.resData.dataTime, sliceLayerInfo.value.resData.timeSeries);
//       }

//       if (modeSelectList.value.length) modeSelectList.value = modeSelectList.value.slice(0, 1);
//       else modeSelectList.value = [Enum_ForecastMode.ECTHIN];

//       if (!sliceLayerInfo.value) return selectElementHandle(Enum_ForecastElement.PRE24);

//       generateMultiTimeForecastDateScaleList();
//       generateMultiTimeSplitScreenParams();

//       // 从single或compare切换到该展示模式时 填充位势高度场/风场信息
//       if (lastDisplayTag === "single") {
//         splitScreenGeoHeightInfo.value = getGPHGeojsonRes().L_GPH;
//         splitScreenSLPInfo.value = getGPHGeojsonRes().SLP;
//         splitScreenWindInfo.value = { height: ModeForecast.getWindTexClipParams()?.height?.resData, ground: ModeForecast.getWindTexClipParams()?.ground?.resData };
//       }
//       else if (lastDisplayTag === "compare") {
//         splitScreenGeoHeightInfo.value = splitScreenLayerInfo.value[0].height;
//         splitScreenSLPInfo.value = splitScreenLayerInfo.value[0].slp;
//         splitScreenWindInfo.value = splitScreenLayerInfo.value[0].wind;
//       }

//       refreshSplitScreenGeoHeightAndWind();
//       break;
//     case "multiElement":
//       if (modeSelectList.value.length) modeSelectList.value = modeSelectList.value.slice(0, 1);
//       else modeSelectList.value = [Enum_ForecastMode.ECTHIN];

//       selectElementList.value = [Enum_ForecastElement.PRE24, Enum_ForecastElement.TMAX, Enum_ForecastElement.UVA, Enum_ForecastElement.RHA];
//       if (selectElement.value && !selectElementList.value.includes(selectElement.value)) selectElementList.value[3] = selectElement.value;
//       generateModeByMultiElement(lastDisplayTag);
//       break;

//     // case "difference":
//     //   displaySelect.value = display;
//     //   if (modeSelectList.value.length > 2) resetModeSelect(2);
//     //   else for (let i = modeSelectList.value.length; i < 2; i++) {
//     //     for (let j = 0; j < modeOptionList.value.length; j++)
//     //       if (!modeSelectList.value.includes(modeOptionList.value[j])) {
//     //         modeSelectList.value.push(modeOptionList.value[j]);
//     //         break;
//     //       }
//     //   }
//     //   break;
//   }
// };

/** 切换模式 */
const changeModeSelect = async (mode: Enum_ForecastMode, available: boolean) => {
  if (!available) return;
  switch (displaySelect.value) {
    case "single":
      modeSelectList.value = [mode];

      if (currentLayerTag.value === "tex") {
        if (sliceLayerInfo.value) clearSliceLayer();
        drawSliceLayer("changeMode");
      }

      if (currentLayerTag.value === "isoline") {
        if (currentModeJson.value && currentModeJson.value.layer) {
          $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: currentModeJson.value.layer.layerID! });
          currentModeJson.value = undefined;
        }
        drawIsolineLayer();
      }
      break;
    //     case "compare":
    //       if (modeSelectList.value.includes(mode)) { // 移除
    //         const idx = modeSelectList.value.findIndex(item => item === mode);
    //         if (idx !== -1) {
    //           modeSelectList.value.splice(idx, 1);
    //           splitScreenLayerInfo.value.splice(idx, 1);

    //           // 起报时/预报时取并集
    //           let dataTime: string[][] = [], timeSeriesObject: { "-1": string[][], [key: string]: string[][] } = { "-1": [] };
    //           splitScreenLayerInfo.value.forEach((item) => {
    //             dataTime.push(item.texResData.dataTime);

    //             const itemTimeSeries = Object.entries(item.texResData.timeSeries);
    //             itemTimeSeries.forEach((timeItem) => {
    //               if (timeSeriesObject[timeItem[0]]) timeSeriesObject[timeItem[0]].push(timeItem[1]);
    //               else timeSeriesObject[timeItem[0]] = [timeItem[1]];
    //             });
    //           });

    //           let timeSeries: { "-1": string[], [key: string]: string[] } = { "-1": [] };
    //           Object.entries(timeSeriesObject).forEach((item) => {
    //             timeSeries[item[0]] = Array.from(new Set(item[1].flat())).sort((a, b) => parseInt(a) - parseInt(b));
    //           });

    //           // 时间处理  在已进入模式对比情况下 选择/取消模式 不更新起报时 除非当前选中的起报时已不可用
    //           const availableDataTime = Array.from(new Set(dataTime.flat()));
    //           if (!availableDataTime.includes(currentDataDate.value))
    //             handleDateInfo(availableDataTime.sort((a, b) => new Date(a).getTime() - new Date(b).getTime()), timeSeries);
    //           generateCompareSplitScreenParams();
    //           refreshSplitScreenGeoHeightAndWind();
    //         }
    //       }
    //       else { // 新增
    //         modeSelectList.value.push(mode);
    //         const eleInfo = ModeForecast.getElementInfo(selectElement.value!) as ModeForecastType.ElementOptionItem;
    //         ModeForecastAPI.GetTumSlice(mode, selectElement.value!, eleInfo.dateScale).then(async (res) => {
    //           if (res.success && res.data.dataTime.length) {
    //             splitScreenLayerInfo.value.push({ texResData: res.data, wind: {} });

    //             // 时间处理  在已进入模式对比情况下 选择/取消模式 不更新起报时 除非当前选中的起报时已不可用
    //             // const dataTime: string[] = Array.from(new Set([res.data.dataTime, dataDateList.value].flat())).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    //             // const fcstTimeLength = Array.from(new Set([res.data.fcstTimeLength, forecastDateScaleOption.value!.map(String)].flat())).sort((a, b) => parseInt(a) - parseInt(b));
    //             // handleDateInfo(dataTime, fcstTimeLength);
    //             generateCompareSplitScreenParams();
    //           } else {
    //             ElMessage({
    //               ...ModeForecast.elMessageParams, type: "warning",
    //               message: !res.success ? `当前模式无${ModeForecast.getEleCHN(selectElement.value)}` : `当前模式的${ModeForecast.getEleCHN(selectElement.value)}起报时为空`
    //             });
    //             modeSelectList.value.pop();
    //           }

    //           // 更新位势高度场/风场
    //           Promise.all([
    //             ModeForecastAPI.GetGPHGeojson(mode, Enum_ForecastElement.L_GPH),
    //             ModeForecastAPI.GetTumSlice(mode, windSelectLevel.value === 0 ? Enum_ForecastElement.UV : Enum_ForecastElement.L_WIUV, 1)
    //           ]).then((res) => {
    //             if (res[0] && res[0].success) splitScreenLayerInfo.value[splitScreenLayerInfo.value.length - 1].height = res[0].data;
    //             else splitScreenLayerInfo.value[splitScreenLayerInfo.value.length - 1].height = undefined;
    //             if (res[1] && res[1].success) {
    //               splitScreenLayerInfo.value[splitScreenLayerInfo.value.length - 1].wind = windSelectLevel.value === 0 ? { ground: res[1].data } : { height: res[1].data };
    //             } else splitScreenWindInfo.value = undefined;

    //             refreshSplitScreenGeoHeightAndWind();
    //           });
    //         }).catch(err => {
    //           ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + err });
    //           modeSelectList.value.pop();
    //         });
    //       }
    //       break;
    //     case "adjust":
    //     case "multiTime":
    //       modeSelectList.value = [mode];
    //       const eleInfo = ModeForecast.getElementInfo(selectElement.value!) as ModeForecastType.ElementOptionItem;
    //       ModeForecastAPI.GetTumSlice(modeSelectList.value[0], selectElement.value!, eleInfo.dateScale).then(async (res) => {
    //         if (res.success) {
    //           if (!res.data.dataTime.length)
    //             return ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: `当前模式的${ModeForecast.getEleCHN(selectElement.value)}起报时为空` });

    //           sliceLayerInfo.value = { LayerId: modeSelectList.value[0] + "_" + selectElement.value + "_slice", resData: res.data };
    //           handleDateInfo(res.data.dataTime, res.data.timeSeries);

    //           if (displaySelect.value === "adjust") {
    //             let lengthTag = currentAdjustDataDateList.value.length;
    //             // 确保起报时可用
    //             currentAdjustDataDateList.value = [dataDateList.value[dataDateList.value.length - 1]];
    //             const fcstDate = DateAdd("h", forecastDateScale.value, currentAdjustDataDateList.value[0]);
    //             for (let i = dataDateList.value.length - 2; i >= 0; i--) {
    //               const hour = (fcstDate.getTime() - new Date(dataDateList.value[i]).getTime()) / (1000 * 60 * 60);
    //               const hourString = timeToString(new Date(dataDateList.value[i]), "HH");
    //               const fcstTimeLength = sliceLayerInfo.value?.resData.timeSeries[hourString] ?? sliceLayerInfo.value?.resData.timeSeries["-1"];
    //               if (fcstTimeLength.includes(hour.toString())) {
    //                 currentAdjustDataDateList.value.push(dataDateList.value[i]);
    //                 if (currentAdjustDataDateList.value.length === lengthTag) break;
    //               }
    //             }

    //             generateAdjustSplitScreenParams();
    //           }
    //           if (displaySelect.value === "multiTime") {
    //             const index = forecastDateScaleOption.value.findIndex((item) => item === forecastDateScale.value);
    //             multiTimeForecastDateScaleList.value =
    //               forecastDateScaleOption.value.filter((item) => item % forecastDateInterval.value === 0).slice(index, index + multiTimeLength.value);
    //             generateMultiTimeSplitScreenParams();
    //           }

    //           // 更新位势高度场/风场
    //           Promise.all([
    //             heightSelectLevel.value !== undefined ? ModeForecastAPI.GetGPHGeojson(modeSelectList.value[0], Enum_ForecastElement.L_GPH) : undefined,
    //             ModeForecastAPI.GetTumSlice(modeSelectList.value[0], windSelectLevel.value === 0 ? Enum_ForecastElement.UV : Enum_ForecastElement.L_WIUV, 1),
    //             seaLevelPressure.value ? ModeForecastAPI.GetGPHGeojson(modeSelectList.value[0], Enum_ForecastElement.SLP) : undefined
    //           ]).then((res) => {
    //             if (res[0] && res[0].success) splitScreenGeoHeightInfo.value = res[0].data;
    //             else splitScreenGeoHeightInfo.value = undefined;
    //             if (res[1] && res[1].success) {
    //               splitScreenWindInfo.value = windSelectLevel.value === 0 ? { ground: res[1].data } : { height: res[1].data };
    //             } else splitScreenWindInfo.value = undefined;
    //             if (res[2] && res[2].success) splitScreenSLPInfo.value = res[2].data;
    //             else splitScreenSLPInfo.value = undefined;

    //             refreshSplitScreenGeoHeightAndWind();
    //           });
    //         }
    //       }).catch(err => ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + err }));
    //       break;
    //     case "multiElement":
    //       modeSelectList.value = [mode];
    //       await generateModeByMultiElement("multiElement", true);

    //       // 更新位势高度场/风场
    //       Promise.all([
    //         heightSelectLevel.value !== undefined ? ModeForecastAPI.GetGPHGeojson(modeSelectList.value[0], Enum_ForecastElement.L_GPH) : undefined,
    //         ModeForecastAPI.GetTumSlice(modeSelectList.value[0], windSelectLevel.value === 0 ? Enum_ForecastElement.UV : Enum_ForecastElement.L_WIUV, 1),
    //         seaLevelPressure.value ? ModeForecastAPI.GetGPHGeojson(modeSelectList.value[0], Enum_ForecastElement.SLP) : undefined
    //       ]).then((res) => {
    //         if (res[0] && res[0].success) splitScreenGeoHeightInfo.value = res[0].data;
    //         else splitScreenGeoHeightInfo.value = undefined;
    //         if (res[1] && res[1].success)
    //           splitScreenWindInfo.value = windSelectLevel.value === 0 ? { ground: res[1].data } : { height: res[1].data };
    //         else splitScreenWindInfo.value = undefined;
    //         if (res[2] && res[2].success) splitScreenSLPInfo.value = res[2].data;
    //         else splitScreenSLPInfo.value = undefined;

    //         refreshSplitScreenGeoHeightAndWind();
    //       });
    //       break;
    //     case "difference":
  }

  return;
};

/** 绘制切片图层 tag: changeMode | changeElement 切换模式/要素触发该方法  区别为切换模式时尽量更新起报时 切换要素时尽量不更新起报时 */
const drawSliceLayer = async (tag: "changeMode" | "changeElement") => {
  if (!selectElement.value) {
    refreshGeopotentialHeightAndAltitudeWind();
    return;
  }

  currentLayerTag.value = "tex";
  const eleInfo = ModeForecast.getElementInfo(selectElement.value) as ModeForecastType.ElementOptionItem;


  // SPCC模式特殊处理 - 不打开高度面板和高度场
  if (modeSelectList.value[0] === Enum_ForecastMode.SPCC) {
    // 关闭高度面板
    if (sliceLayerCurrentHeight.value !== undefined) {
      sliceLayerCurrentHeight.value = undefined;
      sliceLayerHeightOption.value = [];
      $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "ModeSliceHeightPanel" });
    }

    // 关闭高度场显示
    heightSelectLevel.value = undefined;
    seaLevelPressure.value = false;
    ModeForecast.removeGeopotentialHeightAndAltitudeWind();
  }


  if (Available.AvailableElement[modeSelectList.value[0]]?.includes(selectElement.value))
    ModeForecastAPI.GetTumSlice(modeSelectList.value[0], selectElement.value!, eleInfo.dateScale).then((res) => {
      if (res.success) {
        if (!res.data.dataTime.length)
          return ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: `当前模式的${ModeForecast.getEleCHN(selectElement.value)}起报时为空` });

        // 开启高度面板
        if (eleInfo?.openHeightPanel) openHeightPanel((res.data.height ?? []).map(Number), eleInfo.level ?? 500);

        // // 时间处理 - 兼容新旧格式
        // let timeSeriesData: { [key: string]: string[] } = {};
        // // 检查是否是新格式
        // if (res.data.fcstTimeLength && !res.data.timeSeries) {
        //   // 新格式：将 fcstTimeLength 转换为 timeSeries 格式
        //   const defaultKeys = ["-1", "08", "20"]; // 默认的起报时间
        //   defaultKeys.forEach(key => {
        //     timeSeriesData[key] = res.data.fcstTimeLength;
        //   });
        // } else {
        //   // 旧格式
        //   timeSeriesData = res.data.timeSeries;
        // }

        // 时间处理
        handleDateInfo(res.data.dataTime, res.data.timeSeries, tag === "changeElement");
        // 刷新叠加形势场/风场
        refreshGeopotentialHeightAndAltitudeWind(selectElement.value === Enum_ForecastElement.L_WVFL);

        const dataTime = timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss");
        const fcstTime = timeToString(DateAdd("h", forecastDateScale.value, currentDataDate.value), "yyyyMMddHHmmss");
        let URL = res.data.url.replace("{mode}", modeSelectList.value[0]).replace("{ele}", selectElement.value!).replace("{dataTime}", dataTime).replace("{fcstTime}", fcstTime);
        if (sliceLayerCurrentHeight.value) URL = URL.replace("{height}", sliceLayerCurrentHeight.value.toString());
        sliceLayerInfo.value = { LayerId: modeSelectList.value[0] + "_" + selectElement.value + "_slice", resData: res.data };

        $Bus.MapEvent.Texture.emit("AddSliceTexture", {
          LayerId: sliceLayerInfo.value.LayerId, URL, TexClipParams: res.data, visualEffect: linearFillColor.value ? 1 : 0, isoline: isolineDisplay.value ? {} : undefined,
          showGrid: gridData.value, Mask: maskDisplay.value ? "IntelligentGrid" : undefined, opacity: highLevelSlice.value ? 0 : 1,
          colorCode: getSpecifiedColorCode(selectElement.value),
          workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
        } as any);

        if (selectElement.value === Enum_ForecastElement.L_WVFL)
          ModeForecast.drawSpecialArrowLayer(modeSelectList.value[0], URL, res.data, res.data.timeSeries, res.data.dataTime);
      }
    }).catch(err => ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + err }));
  else { // 模式不支持要素情况下 更新叠加形势场/风场为新的模式
    refreshGeopotentialHeightAndAltitudeWind();
    ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: t('currentModeNotAvailable') + ModeForecast.getEleCHN(selectElement.value) });
  }
};

/** 根据接口返回的 起报时间序列/预报时序列 修改当前起报时/预报时/时效间隔  同模式下看同一起报时数据/不同模式将起报时数据切到最新 */
const handleDateInfo = (dataTime: string[], timeSeries: { "-1": string[], [key: string]: string[] }, noUpdateDataTime?: boolean) => {
  // 起报时间调整 切换至最新起报时 并尽量满足当前预报时
  dataDateList.value = dataTime;
  if (!noUpdateDataTime || (noUpdateDataTime && !dataTime.includes(currentDataDate.value))) currentDataDate.value = dataTime.at(-1) as string;
  const hourTag = (new Date(currentDataDate.value).getTime() - new Date(lastDataDate.value).getTime()) / (1000 * 60 * 60);

  const hourString = timeToString(new Date(currentDataDate.value), "HH");
  const fcstTimeLength = timeSeries[hourString] ?? timeSeries["-1"];
  // 预报时效间隔 / 预报时效调整
  forecastDateScaleOption.value = fcstTimeLength.map(Number);
  forecastDateIntervalOption.value = ModeForecast.generateForecastDateIntervalOption(forecastDateScaleOption.value);
  forecastDateInterval.value = forecastDateIntervalOption.value[0]; // 预报时效间隔默认取能展示所有预报时的间隔

  if (forecastDateScaleOption.value.includes(forecastDateScale.value - hourTag)) forecastDateScale.value = forecastDateScale.value - hourTag;
  else forecastDateScale.value = forecastDateScaleOption.value[0];

  lastDataDate.value = currentDataDate.value; // 存储起报时间
};

/** 更新切片图层 适用于更新 预报时/起报时 */
const updateSliceLayer = () => {
  if (sliceLayerInfo.value && selectElement.value) {
    const dataTime = timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss");
    const fcstTime = timeToString(DateAdd("h", forecastDateScale.value, currentDataDate.value), "yyyyMMddHHmmss");
    let URL = sliceLayerInfo.value.resData.url.replace("{mode}", modeSelectList.value[0]).replace("{ele}", selectElement.value).replace("{dataTime}", dataTime).replace("{fcstTime}", fcstTime);
    if (sliceLayerCurrentHeight.value) URL = URL.replace("{height}", sliceLayerCurrentHeight.value.toString());
    $Bus.MapEvent.Texture.emit("RemoveSliceTexture", { LayerId: sliceLayerInfo.value.LayerId });
    $Bus.MapEvent.Texture.emit("AddSliceTexture", {
      LayerId: sliceLayerInfo.value.LayerId, URL, TexClipParams: sliceLayerInfo.value.resData, visualEffect: linearFillColor.value ? 1 : 0,
      showGrid: gridData.value, Mask: maskDisplay.value ? "IntelligentGrid" : undefined, isoline: isolineDisplay.value ? {} : undefined,
      colorCode: getSpecifiedColorCode(selectElement.value),
      workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
    } as any);
  }
};

/** 清空切片图层 */
const clearSliceLayer = () => {
  if (sliceLayerInfo.value) {
    $Bus.MapEvent.Texture.emit("RemoveSliceTexture", { LayerId: sliceLayerInfo.value.LayerId });
    sliceLayerInfo.value = undefined;
  }
};

/** 切换高度层高度 */
const changeSliceLayerHeight = (height: number) => {
  if (!highLevelSlice.value) {
    sliceLayerCurrentHeight.value = height;
    switch (displaySelect.value) {
      case "single":
        updateSliceLayer();
        break;
      //   case "compare":
      //     generateCompareSplitScreenParams();
      //     break;
      //   case "adjust":
      //     generateAdjustSplitScreenParams();
      //     break;
      //   case "multiTime":
      //     generateMultiTimeSplitScreenParams();
      //     break;
    }
  } else {
    const idx = highLevelSliceHeight.value.findIndex((item) => item === height);
    if (idx === -1) highLevelSliceHeight.value.push(height);
    else highLevelSliceHeight.value.splice(idx, 1);
  }
};

/** 绘制等值线图层 */
const drawIsolineLayer = async (tag?: "changeElement") => {
  currentLayerTag.value = "isoline";

  if (currentModeJson.value && currentModeJson.value.mode === modeSelectList.value[0] && currentModeJson.value.ele === selectElement.value) {
    const fcstDate = DateAdd("h", forecastDateScale.value, currentDataDate.value);
    const resUrl = currentModeJson.value.res.url.replace("{yyyy}", timeToString(new Date(currentDataDate.value), "yyyy"))
      .replace("{yyyyMMdd}", timeToString(new Date(currentDataDate.value), "yyyyMMdd")).replace("{level}", "0")
      .replace("{dataTime}", timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss"))
      .replace("{fcstTime}", timeToString(fcstDate, "yyyyMMddHHmmss"));
    fetch(resUrl).then(response => response.json()).then(data => {
      const Layer: Layer = {
        layerName: `ModeJson_${modeSelectList.value[0]}_${selectElement.value}`, isDisplay: true, layerSource: "ModeCompare", isDataLayer: true,
        renderLayerList: [
          {
            layerName: "line", renderLayerLevel: RenderLayerLevel.lineLayer, drawLayerType: DrawLayerType.Line,
            properties: { type: "line", paint: { "line-color": ["coalesce", ["get", "color"], '#0000FF'], "line-width": 2 } },
            source: { type: "geojson", data }
          },
          {
            layerName: "text", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol,
            properties: {
              type: "symbol", paint: { "text-color": ["coalesce", ["get", "color"], '#0000FF'], "text-halo-color": "white", "text-halo-width": 2 },
              layout: { "symbol-placement": "line", "text-allow-overlap": true, "symbol-spacing": 500, "text-field": ["coalesce", ["get", "value"], ''] }
            }, source: { type: "geojson", data }
          }
        ]
      };

      currentModeJson.value!.url = resUrl;
      currentModeJson.value!.layer = Layer;
      $Bus.MapEvent.Layer.emit("AddSpecifyLayer", { Layer: currentModeJson.value!.layer });
    }).catch(error => ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + error }));
  } else if (selectElement.value && Available.AvailableElement[modeSelectList.value[0]]?.includes(selectElement.value))
    ModeForecastAPI.GetGPHGeojson(modeSelectList.value[0], selectElement.value).then((res) => {
      if (res && res.success) {
        if (!res.data.url) {
          if (currentModeJson.value && currentModeJson.value.layer) $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: currentModeJson.value.layer.layerID! });
          currentModeJson.value = undefined;
        } else {
          if (!res.data.dataTime.length)
            return ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: `当前模式的${ModeForecast.getEleCHN(selectElement.value)}起报时为空` });

          // 时间处理
          handleDateInfo(res.data.dataTime, res.data.timeSeries, tag === "changeElement");
          // 刷新叠加形势场/风场
          refreshGeopotentialHeightAndAltitudeWind();

          const fcstDate = DateAdd("h", forecastDateScale.value, currentDataDate.value);
          const resUrl = res.data.url.replace("{yyyy}", timeToString(new Date(currentDataDate.value), "yyyy"))
            .replace("{yyyyMMdd}", timeToString(new Date(currentDataDate.value), "yyyyMMdd")).replace("{level}", "0")
            .replace("{dataTime}", timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss"))
            .replace("{fcstTime}", timeToString(fcstDate, "yyyyMMddHHmmss"));

          if (resUrl !== currentModeJson.value?.url)
            fetch(resUrl).then(response => response.json()).then(data => {
              const Layer: Layer = {
                layerName: `ModeJson_${modeSelectList.value[0]}_${selectElement.value}`, isDisplay: true, layerSource: "ModeCompare", isDataLayer: true,
                renderLayerList: [
                  {
                    layerName: "line", renderLayerLevel: RenderLayerLevel.lineLayer, drawLayerType: DrawLayerType.Line,
                    properties: { type: "line", paint: { "line-color": ["coalesce", ["get", "color"], '#0000FF'], "line-width": 2 } },
                    source: { type: "geojson", data }
                  },
                  {
                    layerName: "text", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol,
                    properties: {
                      type: "symbol", paint: { "text-color": ["coalesce", ["get", "color"], '#0000FF'], "text-halo-color": "white", "text-halo-width": 2 },
                      layout: { "symbol-placement": "line", "text-allow-overlap": true, "symbol-spacing": 500, "text-field": ["coalesce", ["get", "value"], ''] }
                    }, source: { type: "geojson", data }
                  }
                ]
              };

              currentModeJson.value = { url: resUrl, layer: Layer, res: res.data, mode: modeSelectList.value[0], ele: selectElement.value! };
              $Bus.MapEvent.Layer.emit("AddSpecifyLayer", { Layer: currentModeJson.value.layer });
            }).catch(error => ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + error }));
        }
      }
    });
  else {
    // 模式不支持要素情况下 更新叠加形势场/风场为新的模式
    refreshGeopotentialHeightAndAltitudeWind();
    ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: t('currentModeNotAvailable') + ModeForecast.getEleCHN(selectElement.value) });
    if (currentModeJson.value && currentModeJson.value.layer) {
      $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: currentModeJson.value.layer.layerID! });
      currentModeJson.value = undefined;
    }
  }
};

/** 快捷切换起报时按钮 */
const quickChangeForecastDate = (tag: "next" | "previous") => {
  const index = dataDateList.value.findIndex((item) => item === currentDataDate.value);
  if (tag === "previous") {
    if (index === 0) return ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: "当前已是最新起报时" });
    else currentDataDate.value = dataDateList.value[index - 1];
  }

  if (tag === "next") {
    if (index === dataDateList.value.length - 1) return ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: "无更早起报时" });
    else currentDataDate.value = dataDateList.value[index + 1];
  }

  changeForecastDate();
};

/** 修改起报时间 */
const changeForecastDate = async () => {
  // 根据前起报时间 维持预报时间
  const hourDiff = (new Date(lastDataDate.value).getTime() - new Date(currentDataDate.value).getTime()) / (1000 * 60 * 60);
  const hourTemp = forecastDateScale.value + hourDiff;
  const hourString = timeToString(new Date(currentDataDate.value), "HH");

  if (displaySelect.value !== "compare") {
    forecastDateScaleOption.value = (sliceLayerInfo.value!.resData.timeSeries[hourString] ?? sliceLayerInfo.value!.resData.timeSeries["-1"]).map(Number);
  } else {
    // 合并timeSeries
    let timeSeriesObject: { "-1": string[][], [key: string]: string[][] } = { "-1": [] };
    for (let i = 0; i < splitScreenLayerInfo.value.length; i++) {
      const itemTimeSeries = Object.entries(splitScreenLayerInfo.value[i].texResData.timeSeries);
      itemTimeSeries.forEach((item) => {
        if (timeSeriesObject[item[0]]) timeSeriesObject[item[0]].push(item[1]);
        else timeSeriesObject[item[0]] = [item[1]];
      });
    }
    let timeSeries: { "-1": string[], [key: string]: string[] } = { "-1": [] };
    Object.entries(timeSeriesObject).forEach((item) => {
      timeSeries[item[0]] = Array.from(new Set(item[1].flat())).sort((a, b) => parseInt(a) - parseInt(b));
    });
    forecastDateScaleOption.value = (timeSeries[hourString] ?? timeSeries["-1"]).map(Number);
  }

  if (forecastDateScaleOption.value.includes(hourTemp)) forecastDateScale.value = hourTemp;
  else forecastDateScale.value = forecastDateScaleOption.value[0];

  switch (displaySelect.value) {
    case "single":
      if (currentLayerTag.value === "isoline") drawIsolineLayer();
      else updateSliceLayer();
      refreshGeopotentialHeightAndAltitudeWind();
      break;
    // case "compare":
    //   generateCompareSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "multiTime":
    //   generateMultiTimeForecastDateScaleList();
    //   generateMultiTimeSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "multiElement":
    //   generateMultiElementSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "difference":
  }

  lastDataDate.value = currentDataDate.value; // 更新前起报时间
};

/** 修改预报调整起报时间 */
const changeAdjustForecastDate = () => {
  currentAdjustDataDateList.value.sort((a, b) => new Date(b).getTime() - new Date(a).getTime());
  //   generateAdjustSplitScreenParams();
  // refreshSplitScreenGeoHeightAndWind();
};

/** 修改预报时间 ignoreMultiTime: 预报时效间隔切换引起的预报时间修改 忽略index校验 */
const changeDataDate = async (dis: number, index: number, ignoreMultiTime?: boolean) => {
  if (!ignoreMultiTime && displaySelect.value === 'multiTime' && index > (forecastDateScaleOption.value!.length - multiTimeLength.value)) return;
  forecastDateScale.value = dis;

  switch (displaySelect.value) {
    case "single":

      if (currentLayerTag.value === "isoline") drawIsolineLayer();
      else updateSliceLayer();
      refreshGeopotentialHeightAndAltitudeWind();
      break;
    // case "compare":
    //   generateCompareSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "adjust":
    //   generateAdjustSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "multiTime":
    //   multiTimeForecastDateScaleList.value =
    //     forecastDateScaleOption.value.filter((item) => item % forecastDateInterval.value === 0).slice(index, index + multiTimeLength.value);
    //   generateMultiTimeSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "multiElement":
    //   generateMultiElementSplitScreenParams();
    //   refreshSplitScreenGeoHeightAndWind();
    //   break;
    // case "difference":
  }

};

/** 修改预报时间间隔 */
const changeForecastDateInterval = () => {
  const newDateScaleOption = forecastDateScaleOption.value.filter((item) => item % forecastDateInterval.value === 0);
  if (displaySelect.value === "multiTime") changeDataDate(newDateScaleOption[0], 0, true);
  else if (!newDateScaleOption.includes(forecastDateScale.value)) changeDataDate(newDateScaleOption[0], 0);
};

/** 选中指定要素 force: 忽略要素相同强制重绘 ignoreRemove: 忽略移除图层 */
const selectElementHandle = async (ele: Enum_ForecastElement, isIsoline?: boolean, force?: boolean, ignoreRemove?: boolean) => {
  const lastEle = selectElement.value;
  if (!force) {
    if (displaySelect.value === "single" && ele === selectElement.value) {
      selectElement.value = undefined;
      if (sliceLayerInfo.value) clearSliceLayer();
      if (highLevelSlice.value) highLevelSliceClickHandle();
      return;
    }
    if (displaySelect.value !== "multiElement" && (ele === Enum_ForecastElement.未知 || selectElement.value === ele)) return;
  }
  // 多要素特殊处理
  if (displaySelect.value !== "multiElement") selectElement.value = ele;

  // 关闭高度面板
  const eleInfo = ModeForecast.getElementInfo(ele) as ModeForecastType.ElementOptionItem;
  if (sliceLayerCurrentHeight.value !== undefined && !eleInfo.openHeightPanel) {
    sliceLayerCurrentHeight.value = undefined;
    sliceLayerHeightOption.value = [];
    $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "ModeSliceHeightPanel" });
  }

  // 气压+24小时变压 特殊处理
  if (eleInfo.specifiedGeoHeight !== undefined) {
    if (eleInfo.specifiedGeoHeight === 0) {
      if (heightSelectLevel.value !== undefined) changeSelectLevel('height', heightSelectLevel.value);
      switchSeaLevelPressure();
    } else {
      if (seaLevelPressure.value) switchSeaLevelPressure();
      if (heightSelectLevel.value !== eleInfo.specifiedGeoHeight) changeSelectLevel('height', eleInfo.specifiedGeoHeight);
    }
  }

  // 水汽通量特殊处理
  if (selectElement.value === Enum_ForecastElement.L_WVFL) windSelectLevel.value = -9999;
  else if (windSelectLevel.value === -9999) windSelectLevel.value = 0; // 取消水汽通量矢量选中

  // 风特殊处理
  if (eleInfo.isLinearColor) linearFillColor.value = true;
  else if (lastEle && ModeForecast.getElementInfo(lastEle)?.isLinearColor) linearFillColor.value = false;

  switch (displaySelect.value) {
    case "single":
      // 移除图层
      if (!ignoreRemove)
        if (currentLayerTag.value === "isoline") {
          if (currentModeJson.value && currentModeJson.value.layer) $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: currentModeJson.value.layer.layerID! });
          currentModeJson.value = undefined;
        } else if (sliceLayerInfo.value) clearSliceLayer();

      // 新增图层
      if (isIsoline) drawIsolineLayer("changeElement");
      else drawSliceLayer("changeElement");
      break;
    // case "compare":
    //   // 保留选中模式 过滤无该要素的模式  如果模式数量减少则尝试补齐
    //   let tag = modeSelectList.value.length;
    //   for (let i = tag - 1; i >= 0; i--)
    //     if (!Available.AvailableElement[modeSelectList.value[i]]?.includes(selectElement.value!))
    //       modeSelectList.value.splice(i, 1);

    //   if (modeSelectList.value.length < tag)
    //     for (let key in Available.AvailableElement)
    //       if (Available.AvailableElement[key as Enum_ForecastMode]?.includes(selectElement.value!) && !modeSelectList.value.includes(key as Enum_ForecastMode)) {
    //         modeSelectList.value.push(key as Enum_ForecastMode);
    //         if (modeSelectList.value.length === tag) break;
    //       }

    //   generateCompareModeByElement();
    //   break;
    // case "adjust":
    // case "multiTime":
    //   ModeForecastAPI.GetTumSlice(modeSelectList.value[0], selectElement.value!, eleInfo.dateScale).then(async (res) => {
    //     if (res.success) {
    //       if (!res.data.dataTime.length)
    //         return ElMessage({ ...ModeForecast.elMessageParams, type: "warning", message: `当前模式的${ModeForecast.getEleCHN(selectElement.value)}起报时为空` });

    //       // 开启高度面板
    //       if (eleInfo.openHeightPanel) openHeightPanel(res.data.height!, eleInfo.level ?? 500);

    //       sliceLayerInfo.value = { LayerId: modeSelectList.value[0] + "_" + selectElement.value + "_slice", resData: res.data };
    //       handleDateInfo(res.data.dataTime, res.data.timeSeries, true); // 切换要素的时候尽量不更新起报时

    //       if (displaySelect.value === "adjust") {
    //         const lengthTag = currentAdjustDataDateList.value.length === 0 ? 4 : currentAdjustDataDateList.value.length;
    //         const dataIdx = dataDateList.value.findIndex((item) => item === currentDataDate.value);
    //         // 确保起报时可用
    //         currentAdjustDataDateList.value = [dataDateList.value[dataIdx]];
    //         const fcstDate = DateAdd("h", forecastDateScale.value, currentAdjustDataDateList.value[0]);
    //         for (let i = dataIdx - 1; i >= 0; i--) {
    //           const hour = (fcstDate.getTime() - new Date(dataDateList.value[i]).getTime()) / (1000 * 60 * 60);
    //           const hourString = timeToString(new Date(dataDateList.value[i]), "HH");
    //           const fcstTimeLength = sliceLayerInfo.value?.resData.timeSeries[hourString] ?? sliceLayerInfo.value?.resData.timeSeries["-1"];
    //           if (fcstTimeLength.includes(hour.toString())) {
    //             currentAdjustDataDateList.value.push(dataDateList.value[i]);
    //             if (currentAdjustDataDateList.value.length === lengthTag) break;
    //           }
    //         }
    //         generateAdjustSplitScreenParams(true);
    //       }
    //       if (displaySelect.value === "multiTime") {
    //         generateMultiTimeForecastDateScaleList();
    //         generateMultiTimeSplitScreenParams(true);
    //       }

    //       refreshSplitScreenGeoHeightAndWind();
    //     }
    //   }).catch(err => ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + err }));
    //   break;
    // case "multiElement":
    //   if (selectElementList.value.includes(ele)) { // 移除
    //     const idx = selectElementList.value.findIndex((item) => item === ele);
    //     if (idx !== -1) {
    //       selectElementList.value.splice(idx, 1);
    //       splitScreenLayerInfo.value.splice(idx, 1);

    //       // 起报时/预报时取并集
    //       let dataTime: string[][] = [], timeSeriesObject: { "-1": string[][], [key: string]: string[][] } = { "-1": [] };
    //       splitScreenLayerInfo.value.forEach((item) => {
    //         dataTime.push(item.texResData.dataTime);

    //         const itemTimeSeries = Object.entries(item.texResData.timeSeries);
    //         itemTimeSeries.forEach((timeItem) => {
    //           if (timeSeriesObject[timeItem[0]]) timeSeriesObject[timeItem[0]].push(timeItem[1]);
    //           else timeSeriesObject[timeItem[0]] = [timeItem[1]];
    //         });
    //       });

    //       let timeSeries: { "-1": string[], [key: string]: string[] } = { "-1": [] };
    //       Object.entries(timeSeriesObject).forEach((item) => {
    //         timeSeries[item[0]] = Array.from(new Set(item[1].flat())).sort((a, b) => parseInt(a) - parseInt(b));
    //       });

    //       // 时间处理
    //       handleDateInfo((Array.from(new Set(dataTime.flat()))).sort((a, b) => new Date(a).getTime() - new Date(b).getTime()), timeSeries);
    //       generateMultiElementSplitScreenParams();
    //       refreshSplitScreenGeoHeightAndWind();
    //     }
    //   } else { // 新增
    //     selectElementList.value.push(ele);

    //     const eleInfo = ModeForecast.getElementInfo(ele) as ModeForecastType.ElementOptionItem;
    //     ModeForecastAPI.GetTumSlice(modeSelectList.value[0], ele, eleInfo.dateScale).then(async (res) => {
    //       if (res.success && res.data.dataTime.length) {
    //         splitScreenLayerInfo.value.push({ texResData: res.data, wind: {} });

    //         // 时间处理 起报时/预报时取并集
    //         const dataTime: string[] = Array.from(new Set([res.data.dataTime, dataDateList.value].flat())).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    //         // 合并timeSeries
    //         let timeSeriesObject: { "-1": string[][], [key: string]: string[][] } = { "-1": [] };
    //         for (let i = 0; i < splitScreenLayerInfo.value.length; i++) {
    //           const itemTimeSeries = Object.entries(splitScreenLayerInfo.value[i].texResData.timeSeries);
    //           itemTimeSeries.forEach((item) => {
    //             if (timeSeriesObject[item[0]]) timeSeriesObject[item[0]].push(item[1]);
    //             else timeSeriesObject[item[0]] = [item[1]];
    //           });
    //         }
    //         let timeSeries: { "-1": string[], [key: string]: string[] } = { "-1": [] };
    //         Object.entries(timeSeriesObject).forEach((item) => {
    //           timeSeries[item[0]] = Array.from(new Set(item[1].flat())).sort((a, b) => parseInt(a) - parseInt(b));
    //         });

    //         handleDateInfo(dataTime, timeSeries);
    //         generateMultiElementSplitScreenParams();

    //         splitScreenLayerInfo.value[splitScreenLayerInfo.value.length - 1].height = splitScreenLayerInfo.value[0].height;
    //         refreshSplitScreenGeoHeightAndWind();
    //       } else {
    //         ElMessage({
    //           ...ModeForecast.elMessageParams, type: "warning",
    //           message: !res.success ? `当前模式无${ModeForecast.getEleCHN(selectElement.value)}` : `当前模式的${ModeForecast.getEleCHN(selectElement.value)}起报时为空`
    //         });
    //         selectElementList.value.pop();
    //       }
    //     }).catch(err => {
    //       ElMessage({ ...ModeForecast.elMessageParams, type: "error", message: "请求错误 " + err });
    //       selectElementList.value.pop();
    //     });
    //   }
    //   break;
    // case "difference":
  }
  //   //截图组件打开的情况下
  //   if (exportImagePanel.value) {
  //     setTimeout(() => {
  //       updateExprotImg(true)
  //     }, 500);
  //   }
};

// /** 模式对比 根据要素获取URL */
// const generateCompareModeByElement = async () => {
//   const eleInfo = ModeForecast.getElementInfo(selectElement.value!) as ModeForecastType.ElementOptionItem;
//   const promiseList: Promise<{ success: boolean, data: ModeForecastType.TexClipParams }>[] = [];

//   for (let i = 0; i < modeSelectList.value.length; i++)
//     promiseList.push(ModeForecastAPI.GetTumSlice(modeSelectList.value[i], selectElement.value!, eleInfo.dateScale));

//   Promise.all(promiseList).then(async (res) => {
//     // 起报时/预报时取并集
//     let dataTime: string[][] = [], timeSeriesObject: { "-1": string[][], [key: string]: string[][] } = { "-1": [] };
//     for (let i = 0; i < res.length; i++) {
//       dataTime.push(res[i].data.dataTime);

//       const itemTimeSeries = Object.entries(res[i].data.timeSeries);
//       itemTimeSeries.forEach((item) => {
//         if (timeSeriesObject[item[0]]) timeSeriesObject[item[0]].push(item[1]);
//         else timeSeriesObject[item[0]] = [item[1]];
//       });
//     }

//     let timeSeries: { "-1": string[], [key: string]: string[] } = { "-1": [] };
//     Object.entries(timeSeriesObject).forEach((item) => {
//       timeSeries[item[0]] = Array.from(new Set(item[1].flat())).sort((a, b) => parseInt(a) - parseInt(b));
//     });

//     // 时间处理
//     handleDateInfo((Array.from(new Set(dataTime.flat()))).sort((a, b) => new Date(a).getTime() - new Date(b).getTime()), timeSeries);

//     splitScreenLayerInfo.value = [];
//     for (let i = 0; i < res.length; i++)
//       splitScreenLayerInfo.value.push({ texResData: res[i].data, wind: {} });
//     // 开启高度面板
//     if (eleInfo.openHeightPanel)
//       for (let i = 0; i < splitScreenLayerInfo.value.length; i++) {
//         if (splitScreenLayerInfo.value[i].texResData.height) openHeightPanel(splitScreenLayerInfo.value[i].texResData.height!, eleInfo.level ?? 500);
//         break;
//       }

//     generateCompareSplitScreenParams(true);

//     // 叠加位势高度场
//     const GPHGeojsonPromiseList: Promise<{ success: boolean, data: ModeForecastType.GeoJsonParams }>[] = [];
//     const GPHEle = heightSelectLevel.value !== 0 ? Enum_ForecastElement.L_GPH : Enum_ForecastElement.SLP;
//     for (let i = 0; i < modeSelectList.value.length; i++)
//       GPHGeojsonPromiseList.push(ModeForecastAPI.GetGPHGeojson(modeSelectList.value[i], GPHEle));

//     // 叠加风场
//     const windFieldPromiseList: Promise<{ success: boolean, data: ModeForecastType.TexClipParams }>[] = [];
//     const windEle = windSelectLevel.value === 0 ? Enum_ForecastElement.UV : Enum_ForecastElement.L_WIUV;
//     for (let i = 0; i < modeSelectList.value.length; i++)
//       windFieldPromiseList.push(ModeForecastAPI.GetTumSlice(modeSelectList.value[i], windEle, 1));

//     Promise.all([Promise.all(GPHGeojsonPromiseList), Promise.all(windFieldPromiseList)]).then((res) => {
//       const GPHGeojsonRes = res[0], windFieldRes = res[1];

//       for (let i = 0; i < GPHGeojsonRes.length; i++) {
//         if (GPHGeojsonRes[i] && GPHGeojsonRes[i].success && GPHGeojsonRes[i].data.url) splitScreenLayerInfo.value[i].height = GPHGeojsonRes[i].data;
//         else splitScreenLayerInfo.value[i].height = undefined;
//       }

//       for (let i = 0; i < windFieldRes.length; i++) {
//         if (windFieldRes[i] && windFieldRes[i].success)
//           splitScreenLayerInfo.value[i].wind = windSelectLevel.value === 0 ? { ground: windFieldRes[i].data } : { height: windFieldRes[i].data };
//         else splitScreenLayerInfo.value[i].wind = {};
//       }

//       refreshSplitScreenGeoHeightAndWind();
//     });
//   });
// };

// /** 模式对比 多屏生成参数 */
// const generateCompareSplitScreenParams = (updateColorBar?: boolean) => {
//   const dataTime = timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss");
//   const fcstTime = timeToString(DateAdd("h", forecastDateScale.value, currentDataDate.value), "yyyyMMddHHmmss");

//   // 切片纹理图处理
//   const SplitScreenParams: ModeCompareEvents["SplitScreenHandle"]["list"] = [];
//   for (let i = 0; i < splitScreenLayerInfo.value.length; i++) {
//     let URL = splitScreenLayerInfo.value[i].texResData.url.replace("{mode}", modeSelectList.value[i]).replace("{ele}", selectElement.value!)
//       .replace("{dataTime}", dataTime).replace("{fcstTime}", fcstTime);
//     if (sliceLayerCurrentHeight.value) URL = URL.replace("{height}", sliceLayerCurrentHeight.value.toString());

//     SplitScreenParams.push({
//       url: URL, mode: ModeForecast.getModeLabel(modeSelectList.value[i]), ele: ModeForecast.getEleCHN(selectElement.value),
//       texClipParams: splitScreenLayerInfo.value[i].texResData, dataDate: currentDataDate.value, fcstDateScale: forecastDateScale.value
//     });
//   }

//   $Self.ApplyEvents.ModeCompare.emit("SplitScreenHandle", { display: "compare", list: SplitScreenParams, updateColorBar });
// };

// /** 预报调整 多屏生成参数 */
// const generateAdjustSplitScreenParams = (updateColorBar?: boolean) => {
//   const mode = ModeForecast.getModeLabel(modeSelectList.value[0]), ele = ModeForecast.getEleCHN(selectElement.value);
//   const standardDataTime = currentAdjustDataDateList.value[0];
//   const fcstTime = timeToString(DateAdd("h", forecastDateScale.value, standardDataTime), "yyyyMMddHHmmss");

//   // 切片纹理图处理
//   const SplitScreenParams: ModeCompareEvents["SplitScreenHandle"]["list"] = [];
//   for (let i = 0; i < currentAdjustDataDateList.value.length; i++) {
//     const diffHour = (new Date(standardDataTime).getTime() - new Date(currentAdjustDataDateList.value[i]).getTime()) / (1000 * 60 * 60);

//     const dataTime = timeToString(new Date(currentAdjustDataDateList.value[i]), "yyyyMMddHHmmss");
//     let URL = sliceLayerInfo.value!.resData.url.replace("{mode}", modeSelectList.value[0]).replace("{ele}", selectElement.value!)
//       .replace("{dataTime}", dataTime).replace("{fcstTime}", fcstTime);
//     if (sliceLayerCurrentHeight.value) URL = URL.replace("{height}", sliceLayerCurrentHeight.value.toString());

//     SplitScreenParams.push({
//       url: URL, mode, ele, texClipParams: sliceLayerInfo.value!.resData, dataDate: currentAdjustDataDateList.value[i], fcstDateScale: diffHour + forecastDateScale.value
//     });
//   }
//   $Self.ApplyEvents.ModeCompare.emit("SplitScreenHandle", { display: "adjust", list: SplitScreenParams, updateColorBar });
// };

// /** 分时展示 多屏生成参数 */
// const generateMultiTimeSplitScreenParams = (updateColorBar?: boolean) => {
//   const mode = ModeForecast.getModeLabel(modeSelectList.value[0]), ele = ModeForecast.getEleCHN(selectElement.value);
//   const dataTime = timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss");

//   // 切片纹理图处理
//   const SplitScreenParams: ModeCompareEvents["SplitScreenHandle"]["list"] = [];
//   for (let i = 0; i < multiTimeForecastDateScaleList.value.length; i++) {
//     const fcstTime = timeToString(DateAdd("h", multiTimeForecastDateScaleList.value[i], currentDataDate.value), "yyyyMMddHHmmss");

//     let URL = sliceLayerInfo.value!.resData.url.replace("{mode}", modeSelectList.value[0]).replace("{ele}", selectElement.value!)
//       .replace("{dataTime}", dataTime).replace("{fcstTime}", fcstTime);
//     if (sliceLayerCurrentHeight.value) URL = URL.replace("{height}", sliceLayerCurrentHeight.value.toString());

//     SplitScreenParams.push({
//       url: URL, mode, ele, texClipParams: sliceLayerInfo.value!.resData, dataDate: currentDataDate.value, fcstDateScale: multiTimeForecastDateScaleList.value[i]
//     });
//   }
//   $Self.ApplyEvents.ModeCompare.emit("SplitScreenHandle", { display: "multiTime", list: SplitScreenParams, updateColorBar });
// };

// /** 修改分时展示的时间序列数 */
// const changeMultiTimeLength = (num: 3 | 4 | 6) => {
//   multiTimeLength.value = num;
//   if (displaySelect.value !== "multiTime") changeDisplayHandle('multiTime');
//   else {
//     const index = forecastDateScaleOption.value.findIndex((item) => item === forecastDateScale.value);
//     multiTimeForecastDateScaleList.value =
//       forecastDateScaleOption.value.filter((item) => item % forecastDateInterval.value === 0).slice(index, index + multiTimeLength.value);
//     generateMultiTimeSplitScreenParams();
//     refreshSplitScreenGeoHeightAndWind();
//   }
// };

// /** 多要素 根据多要素列表获取URL */
// const generateModeByMultiElement = async (lastDisplayTag: "single" | "compare" | "adjust" | "multiTime" | "difference" | "multiElement", withoutHeightWind?: boolean) => {
//   const promiseList: Promise<{ success: boolean, data: ModeForecastType.TexClipParams }>[] = [];
//   for (let i = 0; i < selectElementList.value.length; i++) {
//     const eleInfo = ModeForecast.getElementInfo(selectElementList.value[i]) as ModeForecastType.ElementOptionItem;
//     promiseList.push(ModeForecastAPI.GetTumSlice(modeSelectList.value[0], selectElementList.value[i], eleInfo.dateScale));
//   }

//   await Promise.all(promiseList).then(async (res) => {
//     // 起报时/预报时取并集
//     let dataTime: string[][] = [], timeSeriesObject: { "-1": string[][], [key: string]: string[][] } = { "-1": [] };
//     for (let i = 0; i < res.length; i++) {
//       dataTime.push(res[i].data.dataTime);

//       const itemTimeSeries = Object.entries(res[i].data.timeSeries);
//       itemTimeSeries.forEach((item) => {
//         if (timeSeriesObject[item[0]]) timeSeriesObject[item[0]].push(item[1]);
//         else timeSeriesObject[item[0]] = [item[1]];
//       });
//     }

//     let timeSeries: { "-1": string[], [key: string]: string[] } = { "-1": [] };
//     Object.entries(timeSeriesObject).forEach((item) => {
//       timeSeries[item[0]] = Array.from(new Set(item[1].flat())).sort((a, b) => parseInt(a) - parseInt(b));
//     });

//     // 时间处理
//     handleDateInfo((Array.from(new Set(dataTime.flat()))).sort((a, b) => new Date(a).getTime() - new Date(b).getTime()), timeSeries);

//     splitScreenLayerInfo.value = [];
//     for (let i = 0; i < res.length; i++)
//       splitScreenLayerInfo.value.push({ texResData: res[i].data, wind: {} });

//     generateMultiElementSplitScreenParams();

//     if (!withoutHeightWind) {
//       // 从single或compare切换到该展示模式时 填充位势高度场/风场信息
//       if (lastDisplayTag === "single") {
//         splitScreenGeoHeightInfo.value = getGPHGeojsonRes().L_GPH;
//         splitScreenSLPInfo.value = getGPHGeojsonRes().SLP;
//         splitScreenWindInfo.value = { height: ModeForecast.getWindTexClipParams()?.height?.resData, ground: ModeForecast.getWindTexClipParams()?.ground?.resData };
//       }
//       else if (lastDisplayTag === "compare") {
//         splitScreenGeoHeightInfo.value = splitScreenLayerInfo.value[0].height;
//         splitScreenSLPInfo.value = splitScreenLayerInfo.value[0].slp;
//         splitScreenWindInfo.value = splitScreenLayerInfo.value[0].wind;
//       }
//       refreshSplitScreenGeoHeightAndWind();
//     }
//   });
// };

// /** 多要素 多屏生成参数 */
// const generateMultiElementSplitScreenParams = () => {
//   const dataTime = timeToString(new Date(currentDataDate.value), "yyyyMMddHHmmss");
//   const fcstTime = timeToString(DateAdd("h", forecastDateScale.value, currentDataDate.value), "yyyyMMddHHmmss");

//   // 切片纹理图处理
//   const SplitScreenParams: ModeCompareEvents["SplitScreenHandle"]["list"] = [];
//   for (let i = 0; i < splitScreenLayerInfo.value.length; i++) {
//     let URL = splitScreenLayerInfo.value[i].texResData.url.replace("{mode}", modeSelectList.value[0]).replace("{ele}", selectElementList.value[i])
//       .replace("{dataTime}", dataTime).replace("{fcstTime}", fcstTime);
//     if (sliceLayerCurrentHeight.value) URL = URL.replace("{height}", sliceLayerCurrentHeight.value.toString());

//     SplitScreenParams.push({
//       url: URL, mode: ModeForecast.getModeLabel(modeSelectList.value[0]), ele: ModeForecast.getEleCHN(selectElementList.value[i]),
//       texClipParams: splitScreenLayerInfo.value[i].texResData, dataDate: currentDataDate.value, fcstDateScale: forecastDateScale.value
//     });
//   }

//   $Self.ApplyEvents.ModeCompare.emit("SplitScreenHandle", { display: "multiElement", list: SplitScreenParams });
// };

/** 卫星点击事件 */
const satelliteClickHandle = () => {
  if (displaySelect.value !== "single") return;
  satellite.value = !satellite.value;
  if (satellite.value)
    Fy3LrcDataTextureGridImage.draw({
      label: "色彩增强",
      satellite: Enum__Fy3IrcTextureSatelliteType.风云4号B星,
      el: Enum__Fy3IrcTextureSensorElement["红外云图(色彩增强)"],
      UserApiType: Enum__Fy3IrcUserApiType.查询静止卫星产品,
      State: true
    }, timeToString(DateAdd("h", -1, new Date()), "yyyy-MM-dd HH:mm:00"));
  else {
    Fy3LrcDataTextureGridImage.delete({
      label: "色彩增强",
      satellite: Enum__Fy3IrcTextureSatelliteType.风云4号B星,
      el: Enum__Fy3IrcTextureSensorElement["红外云图(色彩增强)"],
      UserApiType: Enum__Fy3IrcUserApiType.查询静止卫星产品,
      State: false
    })
  }
};

/** 风廓线雷达点击事件 */
const wprClickHandle = () => {
  wpr.value = !wpr.value;
  if (wpr.value) {
    selectWprHeight(0);
    $Bus.BaseEvents.Panel.emit("Open_SpecifyPanel", { Source: "WPRInfoPanel" });
  }
  else {
    wprHeightIndex.value = undefined;
    removeWprHeightLayer();
    $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "WPRInfoPanel" });
  }
};

/** 风廓线雷达选择高度 */
const selectWprHeight = (index: number) => {
  if (index === wprHeightIndex.value && wpr.value) {
    wpr.value = false;
    wprHeightIndex.value = undefined;
    removeWprHeightLayer();
    $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "WPRInfoPanel" });
    return;
  }
  if (index !== wprHeightIndex.value) {
    if (!wpr.value) {
      wpr.value = true;
      $Bus.BaseEvents.Panel.emit("Open_SpecifyPanel", { Source: "WPRInfoPanel" });
    }
    else removeWprHeightLayer();
    wprHeightIndex.value = index;

    Api_GetUparWprByLatLonRange({ height: wprHeightOption[wprHeightIndex.value].h, fluctuate: 500 }).then((res) => {
      if (!res || !res.length) return;

      let date = res[0].dateTime;
      for (let i = 1; i < res.length; i++)
        if (new Date(res[i].dateTime) > new Date(date)) date = res[i].dateTime;
      wprDate.value = date;

      if (wprDisplayTag.value === "isoline") {
        const lineFC = getWprLineFC(res);
        WprLayer.value = {
          layerName: "WprModeComapre", isDisplay: true, isDataLayer: true, layerSource: "ModeCompare", renderLayerList: [
            {
              layerName: "isoline", renderLayerLevel: RenderLayerLevel.lineLayer, drawLayerType: DrawLayerType.Line, source: { type: "geojson", data: lineFC },
              properties: { type: "line", paint: { "line-color": ["coalesce", ["get", "color"], '#0000FF'], "line-width": 2 } }
            },
            {
              layerName: "text", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol, source: { type: "geojson", data: lineFC },
              properties: {
                type: "symbol", paint: { "text-color": ["coalesce", ["get", "color"], '#0000FF'], "text-halo-color": "white", "text-halo-width": 2 },
                layout: {
                  "symbol-placement": "line", "text-allow-overlap": true, "symbol-spacing": 500, "text-field": ["coalesce", ["get", "value"], '']
                }
              }
            }
          ]
        };
      } else {
        const pointFC: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: [] };
        res.forEach((point) => {
          if (point.winS !== undefined && point.winS !== null)
            pointFC.features.push({
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [point.lon, point.lat]
              },
              properties: {
                id: point.staId, name: point.staName, lon: point.lon, lat: point.lat, winS: point.winS, winD: point.winD,
                imgKey: point.winS > 0 ? getWindSpeedImgPath(point.winS, true).key : ''
              }
            });
        });

        WprLayer.value = {
          layerName: "WprModeComapre", isDisplay: true, isDataLayer: true, layerSource: "ModeCompare", renderLayerList: [
            {
              layerName: "point", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol, source: { type: "geojson", data: pointFC },
              properties: { type: "circle", paint: { "circle-radius": 5, "circle-color": "rgba(15, 130, 245, 1)" } }
            },
            {
              layerName: "name", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol, source: { type: "geojson", data: pointFC },
              properties: {
                type: "symbol", layout: {
                  "text-field": ["get", "name"], "text-anchor": 'top', "text-size": 12, "text-offset": [0, 0.5], "text-allow-overlap": true
                },
                paint: { "text-color": "#192d4e", "text-halo-color": "#FFF", "text-halo-width": 1 }
              }
            },
            {
              layerName: "value", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol, source: { type: "geojson", data: pointFC },
              properties: {
                type: "symbol", layout: {
                  "text-field": ["get", "winS"], "text-anchor": 'top', "text-size": 12, "text-offset": [0, -2], "text-allow-overlap": true
                },
                paint: { "text-color": "#192d4e", "text-halo-color": "#FFF", "text-halo-width": 1 }
              }
            },
            {
              layerName: "wind", renderLayerLevel: RenderLayerLevel.pointLayer, drawLayerType: DrawLayerType.Symbol, source: { type: "geojson", data: pointFC },
              properties: {
                type: "symbol", layout: {
                  "icon-image": ['get', 'imgKey'], "icon-rotate": ['get', 'winD'], "icon-offset": [3, -12], "icon-allow-overlap": true
                }
              }
            }
          ]
        };
      }
      $Bus.MapEvent.Layer.emit("AddSpecifyLayer", { Layer: WprLayer.value });
    });
  }

  function getWprLineFC(res: Lists_Type[]) {
    // 格点填值选项
    const gridOpts = {
      "xDelta": 0.05, "xEnd": 120.35, "xSize": 286, "xStart": 106.1,
      "yDelta": 0.05, "yEnd": 27, "ySize": 515, "yStart": 1.3
    };
    const pointList: [number, number, number][] = [];
    res.forEach((point) => {
      if (point.winS !== undefined && point.winS !== null) pointList.push([point.lon, point.lat, point.winS]);
    });

    const xs: number[] = [], ys: number[] = [];
    for (let i = 0; i < gridOpts.xSize; i++)
      xs.push(parseFloat((gridOpts.xStart + i * gridOpts.xDelta).toFixed(2)));
    for (let i = 0; i < gridOpts.ySize; i++)
      ys.push(parseFloat((gridOpts.yStart + i * gridOpts.yDelta).toFixed(2)));

    const gridData: number[][] = interp(pointList, gridOpts);
    const contour = new Contour(gridData, xs, ys, 999999);
    const breaks = [5.5, 8, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7, 37, 41.5, 46.2, 51];
    const contours = contour.tracingContourLines(breaks);
    smoothLines(contours);
    return isolines(contours); // 等值线(GeoJSON)
  }
};

/** 修改风廓线展示形式 */
const changeWprDisplay = (tag: "grid" | "isoline") => {
  if (wprDisplayTag.value === tag) return;

  wprDisplayTag.value = tag;
  removeWprHeightLayer();
  const tempHeight: number = wprHeightIndex.value ?? 0;
  wprHeightIndex.value = undefined;
  selectWprHeight(tempHeight);
};

/** 移除风廓线雷达图层 */
const removeWprHeightLayer = () => {
  if (WprLayer.value && WprLayer.value.layerID) {
    $Bus.MapEvent.Layer.emit("DeleteSpecifyLayerById", { LayerId: WprLayer.value.layerID });
    WprLayer.value = undefined;
  }
};

/** 二级菜单折叠 */
const secondMenuFold = (item: ModeForecastType.SecondMenuItem) => {
  if (item.isFold !== undefined) {
    const currentValue = foldStates.get(item);
    const newValue = !currentValue;
    foldStates.set(item, newValue);
  }
};

// 以下无用 待删除
/** 获取差异序列 @param forecastDate 起报时间 @param selectElement 要素 @param modeArray 模式数组 @param dataTime 预报时 */
const getDifferenceUrls = async (modeArray: Enum_ForecastMode[], dataTime: string): Promise<(string | undefined)[]> => {
  return new Promise((resolve, reject) => {
    const currentDate = currentDataDate.value; // 起报时
    GrayScaleImage.GetRecentGrayImage(modeArray, [selectElement.value ?? Enum_ForecastElement.PRE01], dataTime, currentDate).then((res) => {
      const urlList: (string | undefined)[] = [];
      modeArray.forEach((mode) => {
        if (res[mode] && res[mode].length) {
          const timeUrl = Object.values(res[mode][0])[0] as { [key: string]: string };
          const url = Object.values(timeUrl)[0];
          urlList.push(url ?? undefined);
          if (!url) ElMessage.warning(mode + " 暂无数据");
        }
      });
      resolve(urlList);
    }).catch(err => reject("请求错误 " + err));
  });
};

/** 获取当前预报时间 */
function getCurrentDate() {
  const forecastDateString = currentDataDate.value;
  const currentDate = timeToString(DateAdd("h", forecastDateScale.value, forecastDateString), "yyyy-MM-dd HH:mm:ss");
  return currentDate;
};

/** 生成LayerInfoMarker 仅用于地图视图 */
const layerInfoList = ref<Array<{ url: string, id: string, desc: string, levelIndex?: number, isClip?: boolean }>>([]);
const generateLayerInfoMarker = (url: string, id: string, desc: string, levelIndex?: number, isClip?: boolean) => {
  if (displaySelect.value === "single" && selectElement.value) {
    layerInfoList.value.push({ url, id, desc, levelIndex, isClip });

    if (layerInfoList.value.length === 3) {
      $Bus.MapEvent.Marker.emit("MouseMoveLayerInfo", { infoList: layerInfoList.value });
    } else $Bus.MapEvent.Marker.emit("MouseMoveLayerInfo", { infoList: layerInfoList.value });
  }
};

/** 清空LayerInfoMarker */
const clearLayerInfoMarker = (onlyClearMode?: boolean) => {
  $Bus.MapEvent.Marker.emit("MouseMoveLayerInfo");
  if (onlyClearMode) layerInfoList.value = layerInfoList.value.filter((item) => ["L_GPH", "L_WIUV"].includes(item.id));
  else layerInfoList.value = [];
};

/** 修改累计降水时间区间 */
const changeTotalDataDate = (tag: "start" | "end", date: number) => {
  if (tag === "start") totalForecastDateScale.value[0] = date;
  if (tag === "end") totalForecastDateScale.value[1] = date;
  if (totalForecastDateScale.value[1] <= totalForecastDateScale.value[0]) return ElMessage.warning("请正确选择时间区间");
  if (displaySelect.value === "single") clearLayerInfoMarker();

  // refreshTex();
};




// 以下为要素绘制/形势场/风场相关处理

/** 更新形势场/风场图层 exceptWind: 忽略风的更新  用于叠加其他矢量 */
const refreshGeopotentialHeightAndAltitudeWind = async (exceptWind?: boolean) => {
  const currentMode = modeSelectList.value[0];
  const currentModeAvailableElement = Available.AvailableElement[currentMode] ?? [];
  const supportGroundWind = currentModeAvailableElement.includes(Enum_ForecastElement.UV);
  const supportHeightWind = currentModeAvailableElement.includes(Enum_ForecastElement.L_WIUV);
  heightSelectMode.value = Available.GPHMode.includes(currentMode) ? currentMode : undefined;
  windSelectMode.value = (supportGroundWind || supportHeightWind) ? currentMode : undefined;

  if (windSelectMode.value) {
    if (windSelectLevel.value === 0 && !supportGroundWind) windSelectLevel.value = supportHeightWind ? 925 : undefined;
    else if (windSelectLevel.value !== undefined && windSelectLevel.value !== 0 && !supportHeightWind)
      windSelectLevel.value = supportGroundWind ? 0 : undefined;
  }

  if (heightSelectMode.value) {
    if (heightSelectLevel.value)
      getGeopotentialHeightLayer({ url: "https://www.scsweather.com/HMS/TumApi/Weather/Texture/getGPHGeojson", mode: heightSelectMode.value, height: 0, dataDate: currentDataDate.value, fcstDate: getCurrentDate() }).then(async (res) => {
        if (res !== "nodata") {
          GPHGeojson.value = { origin: res };
          if (maskDisplay.value) GPHGeojson.value.clip = await ModeForecast.geojsonClip(res, "IntelligentGrid");
        }
        $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer",
          res === "nodata" ? res : {
            data: (maskDisplay.value ? GPHGeojson.value.clip! : GPHGeojson.value.origin!),
            workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
          });
      });
    if (seaLevelPressure.value)
      getGeopotentialHeightLayer({ url: "https://www.scsweather.com/HMS/TumApi/Weather/Texture/getGPHGeojson", mode: heightSelectMode.value, height: 0, dataDate: currentDataDate.value, fcstDate: getCurrentDate() }).then(async (res) => {
        if (res !== "nodata") {
          seaLevelPressureGeojson.value = { origin: res };
          if (maskDisplay.value) seaLevelPressureGeojson.value.clip = await ModeForecast.geojsonClip(res, "IntelligentGrid");
        }
        $Bus.ApplyEvents.OtherLayer.emit("SeaLevelPressureLayer",
          res === "nodata" ? "delete" : {
            data: (maskDisplay.value ? seaLevelPressureGeojson.value.clip! : seaLevelPressureGeojson.value.origin!),
            workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
          });
      });
  } else {
    $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", "delete");
    $Bus.ApplyEvents.OtherLayer.emit("SeaLevelPressureLayer", "delete");
  }

  if (windSelectMode.value && !exceptWind && windSelectLevel.value !== undefined)
    ModeForecast.drawSliceWindLayer(windSelectMode.value, currentDataDate.value, getCurrentDate(), windSelectLevel.value, gridWind.value, maskDisplay.value, flowLineDisplay.value);
  else ModeForecast.handleSliceWindLayer("delete");
};


/** 切换层次 force: 忽略当前高度层与所选高度层一致 执行强制刷新 */
const changeSelectLevel = (tag: "wind" | "height", level: number) => {
  if (tag === "wind" && windSelectMode.value) {
    if (windSelectLevel.value === level) {
      windSelectLevel.value = undefined;
      ModeForecast.handleSliceWindLayer("delete");
      return;
    }

    windSelectLevel.value = level;
    if (displaySelect.value === "single") {
      ModeForecast.drawSliceWindLayer(windSelectMode.value, currentDataDate.value, getCurrentDate(), windSelectLevel.value, gridWind.value, maskDisplay.value, flowLineDisplay.value);
    }
    // else 
    //   // refreshSplitScreenGeoHeightAndWind();
  }

  if (tag === "height") {
    if (heightSelectLevel.value === level) {
      heightSelectLevel.value = undefined;
      $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", "delete");
      return;
    }

    heightSelectLevel.value = level;
    if (displaySelect.value === "single") {
      if (heightSelectMode.value)
        getGeopotentialHeightLayer({ url: "https://www.scsweather.com/HMS/TumApi/Weather/Texture/getGPHGeojson", mode: heightSelectMode.value, height: 0, dataDate: currentDataDate.value, fcstDate: getCurrentDate() }).then(async (res) => {
          if (res !== "nodata") {
            GPHGeojson.value = { origin: res };
            if (maskDisplay.value) GPHGeojson.value.clip = await ModeForecast.geojsonClip(res, "IntelligentGrid");
          }
          $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", res === "nodata" ? res : {
            data: (maskDisplay.value ? GPHGeojson.value.clip! : GPHGeojson.value.origin!),
            workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
          });
        });
    }
    // else 
    //   refreshSplitScreenGeoHeightAndWind();
  }
};

/** 海平面气压开关 */
const switchSeaLevelPressure = () => {
  seaLevelPressure.value = !seaLevelPressure.value;

  if (displaySelect.value === "single") {
    if (seaLevelPressure.value && heightSelectMode.value) {
      getGeopotentialHeightLayer({ url: "https://www.scsweather.com/HMS/TumApi/Weather/Texture/getGPHGeojson", mode: heightSelectMode.value, height: 0, dataDate: currentDataDate.value, fcstDate: getCurrentDate() }).then(async (res) => {
        if (res !== "nodata") {
          seaLevelPressureGeojson.value = { origin: res };
          if (maskDisplay.value) seaLevelPressureGeojson.value.clip = await ModeForecast.geojsonClip(res, "IntelligentGrid");
        }
        $Bus.ApplyEvents.OtherLayer.emit("SeaLevelPressureLayer",
          res === "nodata" ? "delete" : {
            data: (maskDisplay.value ? seaLevelPressureGeojson.value.clip! : seaLevelPressureGeojson.value.origin!),
            workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }]
          });
      });
    } else
      $Bus.ApplyEvents.OtherLayer.emit("SeaLevelPressureLayer", "delete");
  }
  // else refreshSplitScreenGeoHeightAndWind();
};

/** 等值线开关 */
const switchIsoline = () => {
  isolineDisplay.value = !isolineDisplay.value;
  if (displaySelect.value === "single" && sliceLayerInfo.value)
    $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, isoline: { tag: isolineDisplay.value } });
};

/** 格点风场开关 */
const switchGridWind = () => {
  if (windSelectLevel.value === undefined) return;
  gridWind.value = !gridWind.value;
  if (gridWind.value) {
    ModeForecast.handleSliceWindLayer("visible");
    refreshGeopotentialHeightAndAltitudeWind();
  } else ModeForecast.handleSliceWindLayer("hidden");
};

/** 格点数据开关 */
const switchGridData = () => {
  gridData.value = !gridData.value;
  if (sliceLayerInfo.value)
    $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, ShowGrid: gridData.value });
};

/** 渐变调色开关 */
const switchVisualEffect = () => {
  linearFillColor.value = !linearFillColor.value;
  if (displaySelect.value === "single" && sliceLayerInfo.value)
    $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, VisualEffect: linearFillColor.value ? 1 : 0 });
};

/** 遮罩显示开关 */
const switchMaskDisplay = async () => {
  maskDisplay.value = !maskDisplay.value;

  if (sliceLayerInfo.value)
    $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, Mask: maskDisplay.value ? "IntelligentGrid" : "delete" });

  if (maskDisplay.value) {
    if (heightSelectLevel.value && GPHGeojson.value.origin) {
      if (!GPHGeojson.value.clip) GPHGeojson.value.clip = await ModeForecast.geojsonClip(GPHGeojson.value.origin, "IntelligentGrid");
      $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", { data: GPHGeojson.value.clip, workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }] });
    }

    if (seaLevelPressure.value && seaLevelPressureGeojson.value.origin) {
      if (!seaLevelPressureGeojson.value.clip) seaLevelPressureGeojson.value.clip = await ModeForecast.geojsonClip(seaLevelPressureGeojson.value.origin, "IntelligentGrid");
      $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", { data: seaLevelPressureGeojson.value.clip, workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }] });
    }

    if (gridWind.value) ModeForecast.maskSliceWindLayer(true);

    if (gridData.value && sliceLayerInfo.value) {
      $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, Mask: "IntelligentGrid" });
    }
  } else {
    if (heightSelectLevel.value)
      $Bus.ApplyEvents.OtherLayer.emit("GeopotentialHeightLayer", { data: GPHGeojson.value.origin!, workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }] });

    if (seaLevelPressure.value)
      $Bus.ApplyEvents.OtherLayer.emit("SeaLevelPressureLayer", { data: seaLevelPressureGeojson.value.origin!, workEnvironment: [{ key: 'Environment', value: Enum_Environment.ModeForecast }] });

    if (gridWind.value) ModeForecast.maskSliceWindLayer(false);

    if (gridData.value && sliceLayerInfo.value) {
      $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, Mask: maskDisplay.value ? "IntelligentGrid" : "delete" });
    }
  }
};

/** 流线显示开关 */
const switchFlowLineDisplay = () => {
  if (windSelectLevel.value === undefined) return;
  flowLineDisplay.value = !flowLineDisplay.value;
  ModeForecast.handleSliceWindLayer(flowLineDisplay.value ? "dynamicVisible" : "dynamicHidden");
};

/** 开启高度选择面板 */
const openHeightPanel = (height: number[], current: number) => {
  sliceLayerHeightOption.value = height.filter(h => [200, 500, 700, 850, 925, 950, 1000].indexOf(h) > -1);
  sliceLayerCurrentHeight.value = current;
  $Bus.BaseEvents.Panel.emit("Open_SpecifyPanel", { Source: "ModeSliceHeightPanel" });
};

/** 更新截图组件状态
 * @params flag 是否更新
 */
const updateExprotImg = (flag: boolean) => {
  if (!flag) {
    $Bus.ApplyEvents.ScreenCaptuer.emit("UpdataScreentCaptureInformation", {
      TitleOptions: {
        Text: '',
        Describe: ''
      },
      ColorBarOptions: {
        CustomColorBar: []
      },
    })
    return
  }
  let Text = ModeForecast.getModeLabel(modeSelectList.value[0]) + " -- " +
    timeToString(new Date(currentDataDate.value), "yyyy-MM-dd HH:00 +") +
    (forecastDateScale.value < 10 ? "00" : (forecastDateScale.value < 100 ? "0" : "")) + forecastDateScale.value + "H(" +
    timeToString(DateAdd("h", forecastDateScale.value, new Date(currentDataDate.value)), "ddHH") + ")"
  let Describe = "";
  if (selectElement.value) {
    Describe += `${sliceLayerCurrentHeight.value ? `${sliceLayerCurrentHeight.value}hPa` : ""}${ModeForecast.getEleCHN(selectElement.value)}(${currentLayerTag.value === "tex" ? ("阴影" + (isolineDisplay.value ? "/等值线" : "") + (gridData.value ? "/格点" : "")) : "等值线"})`;
  }
  if (heightSelectLevel.value && heightSelectMode.value) {
    Describe += (selectElement.value ? "，" : "") + `${heightSelectLevel.value}hPa高度等值线(${ModeForecast.getModeLabel(heightSelectMode.value)})`;
  }
  if (seaLevelPressure.value) {
    Describe += ((selectElement.value || (heightSelectLevel.value && heightSelectMode.value)) ? "，" : "") + `海平面气压等值线(${ModeForecast.getModeLabel(heightSelectMode.value)})`;
  }
  if (windSelectMode.value && windSelectLevel.value !== undefined && (gridWind.value || flowLineDisplay.value)) {
    Describe += ((selectElement.value || (heightSelectLevel.value && heightSelectMode.value) || seaLevelPressure.value) ? "，" : "") + `${ModeForecast.getWindArrowName(windSelectLevel.value, windSelectMode.value, gridWind.value, flowLineDisplay.value)}`;
  }
  $Bus.ApplyEvents.ScreenCaptuer.emit("UpdataScreentCaptureInformation", {
    TitleOptions: {
      Text: Text,
      Describe: Describe
    },
    ColorBarOptions: {
      CustomColorBar: formatColorBarData(ModeCompareRef.value.ColorBarData),
      Arrange: formatColorBarData(ModeCompareRef.value.ColorBarData)[0].options.code.length > 40 ? '2' : '1'
    },
  })
}

/** 重构自定义色标数据结构 */
function formatColorBarData(colorBarData: any): I_SetScreenCaptureModeColorBarItem[] {
  return [{
    options: {
      code: colorBarData.codeKeys.map(Number),
      color: colorBarData.codeColor
    },
    unit: colorBarData.unit ?? ''
  }];
}

// 以下为展示设置中的图表功能

/** 开关垂直廓线面板 */
const verticalProfileClickHandle = () => {
  if (displaySelect.value !== "single") return;
  verticalProfile.value = !verticalProfile.value;
  if (verticalProfile.value) selectPointMutualExclusion("verticalProfile");
  $Bus.MapEvent.Basic.emit('SetMapToolsComponentsDrawUnit', { State: verticalProfile.value, Type: Enum_MapToolsPanelType.垂直廓线 });
};

/** 开关垂直剖面面板 */
const verticalSectionClickHandle = () => {
  if (displaySelect.value !== "single") return;
  verticalSection.value = !verticalSection.value;
  if (verticalSection.value) selectPointMutualExclusion("verticalSection");
  $Bus.MapEvent.Basic.emit('SetMapToolsComponentsDrawUnit', { State: verticalSection.value, Type: Enum_MapToolsPanelType.垂直剖面 });
};

/** 开关高层切片 */
const highLevelSliceClickHandle = () => {
  if (displaySelect.value !== "single" || sliceLayerCurrentHeight.value === undefined) return;
  highLevelSlice.value = !highLevelSlice.value;
  if (highLevelSlice.value && sliceLayerInfo.value) {
    MapStore().MapTarget.dragRotate.enable();

    $Bus.MapEvent.Texture.on("DrawHighLevelSliceComplete", () => {
      if (sliceLayerInfo.value) $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, Opacity: 0 });
      if (gridData.value) switchGridData();
      if (gridWind.value) switchGridWind();
      if (flowLineDisplay.value) switchFlowLineDisplay();

      $Bus.MapEvent.Texture.off("DrawHighLevelSliceComplete");
    });
  } else {
    MapStore().MapTarget.dragRotate.disable();
    MapStore().MapTarget.setPitch(0);
    MapStore().MapTarget.rotateTo(0);

    if (!gridWind.value) switchGridWind();
    if (!flowLineDisplay.value) switchFlowLineDisplay();

    $Bus.MapEvent.Texture.emit('CloseHighLevelSlice');
    if (sliceLayerInfo.value)
      $Bus.MapEvent.Texture.emit("SetSliceTextureParameters", { LayerId: sliceLayerInfo.value.LayerId, Opacity: 1 });
  }
};

/** 开关单点多要素模式对比面板 */
const singleMultiModeClickHandle = () => {
  if (displaySelect.value !== "single") return;
  singleMultiMode.value = !singleMultiMode.value;
  if (singleMultiMode.value) {
    selectPointMutualExclusion("singleMultiMode");

    // 将非08/20起报时取整至08/20
    let dataDate = currentDataDate.value;
    const dataDateHour = new Date(currentDataDate.value).getHours();
    if (dataDateHour !== 8 && dataDateHour !== 20) {
      if (dataDateHour > 20) dataDate = timeToString(new Date(currentDataDate.value), "yyyy-MM-dd 20:00:00");
      else if (dataDateHour > 8) dataDate = timeToString(new Date(currentDataDate.value), "yyyy-MM-dd 08:00:00");
      else dataDate = timeToString(DateAdd("d", -1, currentDataDate.value), "yyyy-MM-dd 20:00:00");
    }

    ModeForecast.switchSingleMultiMode(singleMultiMode.value, {
      element: selectElement, dataDate, fcstDate: timeToString(DateAdd("h", forecastDateScale.value, currentDataDate.value), "yyyy-MM-dd HH:00:00")
    });
  }
  else ModeForecast.switchSingleMultiMode(singleMultiMode.value);
};

/** 开关琼州海峡面板 */
const qiongzhouStraitClickHandle = () => {
  if (displaySelect.value !== "single") return;
  if (!qiongzhouStrait.value) {
    qiongzhouStrait.value = true;
    selectPointMutualExclusion("singleMultiMode");

    $Bus.BaseEvents.Panel.emit("Open_SpecifyPanel", {
      Source: "QiongZhouStraitPanel", info: { beginTime: currentDataDate.value, beginTimeOption: dataDateList.value }
    });
  } else // 为同步直接点击关闭按钮时的状态 按钮active绑定值置false在监听关闭事件中
    $Bus.BaseEvents.Panel.emit("Close_SpecifyPanel", { Source: "QiongZhouStraitPanel" });
};

/** 选点互斥垂直廓线/垂直剖面/单点多模式 P.S. tag为当前开启的状态 */
const selectPointMutualExclusion = (tag: "singleMultiMode" | "verticalProfile" | "verticalSection") => {
  switch (tag) {
    case "singleMultiMode":
      if (verticalProfile.value) verticalProfileClickHandle();
      if (verticalSection.value) verticalSectionClickHandle();
      break;
    case "verticalProfile":
      if (singleMultiMode.value) {
        singleMultiMode.value = false;
        ModeForecast.switchSingleMultiMode(singleMultiMode.value);
      }
      if (verticalSection.value) verticalSectionClickHandle();
      break;
    case "verticalSection":
      if (singleMultiMode.value) {
        singleMultiMode.value = false;
        ModeForecast.switchSingleMultiMode(singleMultiMode.value);
      }
      if (verticalProfile.value) verticalProfileClickHandle();
      break;
  }
};

/** 重新生成分时展示预报时序列 */
const generateMultiTimeForecastDateScaleList = () => {
  const filterForecastDateScaleOption = forecastDateScaleOption.value.filter((item) => item % forecastDateInterval.value === 0);

  let index = filterForecastDateScaleOption.findIndex((item) => item === forecastDateScale.value);
  if (index > filterForecastDateScaleOption.length - multiTimeLength.value) {
    const newIdx = (filterForecastDateScaleOption.length - multiTimeLength.value < 0) ? 0 : (filterForecastDateScaleOption.length - multiTimeLength.value);
    forecastDateScale.value = filterForecastDateScaleOption[newIdx];
    multiTimeForecastDateScaleList.value = filterForecastDateScaleOption.slice(newIdx);
  } else
    multiTimeForecastDateScaleList.value = filterForecastDateScaleOption.slice(index, index + multiTimeLength.value);
};

// /** 快速定位 */
// const quickPositionHandle = (item: { label: string, position: [number, number], zoom: number }) => {
//   if (displaySelect.value === "single")
//     $Bus.MapEvent.Basic.emit("SetZoom", { LanLat: item.position, zoom: item.zoom, speed: 1.5 });
//   else
//     $Self.ApplyEvents.ModeCompare.emit("SplitScreenPositionSet", { position: item.position, zoom: item.zoom });
// };


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[13] || (_cache[13] = _createElementVNode("div", {
      id: "map",
      class: "newmap"
    }, null, -1)),
    _createVNode(NewMap, {
      config: (ModeForecast.MapConfig)
    }, null, 8, ["config"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ModeForecast.SPCCToolbarElementList.value, (group) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.element.filter((item) => !item.isEnsemble), (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (ModeForecast.isSecondMenu(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["mode-forecast-element-subitems", { 'mode-forecast-element-subitems-three-col': item.threeCol }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["mode-forecast-element-subitem", {
                  'mode-forecast-element-subitem-active': (displaySelect.value !== 'multiElement' && selectElement.value === child.key) || (displaySelect.value === 'multiElement' && selectElementList.value.includes(child.key)),
                  'mode-forecast-element-subitem-disabled': (highLevelSlice.value && !child.openHeightPanel) || child.key === _unref(Enum_ForecastElement).未知 || !Available.AvailableElement[modeSelectList.value[0]]?.includes(child.key),
                  'mode-forecast-element-subitem-light': item.light
                }]),
                              onClick: ($event: any) => (selectElementHandle(child.key, child.isIsoline))
                            }, _toDisplayString(child.title), 11, _hoisted_7))
                          }), 256))
                        ], 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["mode-forecast-element-subitem", {
                'mode-forecast-element-subitem-active': (displaySelect.value !== 'multiElement' && selectElement.value === item.key) || (displaySelect.value === 'multiElement' && selectElementList.value.includes(item.key)),
                'mode-forecast-element-subitem-disabled': (highLevelSlice.value && !item.openHeightPanel) || item.key === _unref(Enum_ForecastElement).未知 || !Available.AvailableElement[modeSelectList.value[0]]?.includes(item.key),
                'mode-forecast-element-subitem-light': item.light
              }]),
                          onClick: ($event: any) => (selectElementHandle(item.key, item.isIsoline))
                        }, _toDisplayString(item.title), 11, _hoisted_9)
                      ]))
                ], 64))
              }), 256))
            ])
          ]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(Container, {
        config: ModeForecast.ModeCompareElementPanelContainer,
        class: "mode-compare-element-panel-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('subjectiveForecast')), 1),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectiveModeOptions.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["mode-forecast-mode-card-option", {
                'mode-forecast-element-subitem-active': modeSelectList.value.includes(item.key),
                'mode-forecast-element-subitem-disabled': !item.available
              }]),
                    onClick: ($event: any) => (changeModeSelect(item.key, item.available)),
                    title: item.tips
                  }, _toDisplayString(item.label), 11, _hoisted_15))
                }), 256))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["mode-compare-control-panel-date-box custo-el-input custo-el-select", { 'mode-compare-control-panel-adjust-date-box': displaySelect.value === 'adjust' }])
            }, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('forecastDate')) + ":", 1),
              (displaySelect.value !== 'adjust')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (quickChangeForecastDate('previous'))),
                      style: {"rotate":"-90deg"},
                      class: "icon iconfont icon-jiantouxia"
                    }),
                    _createVNode(_component_el_select, {
                      modelValue: currentDataDate.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentDataDate).value = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (changeForecastDate())),
                      size: "small",
                      teleported: "",
                      placement: "bottom-start",
                      "popper-options": { modifiers: [{ name: 'flip', options: { fallbackPlacements: [] } }] }
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataDateList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: _unref(timeToString)(new Date(item), _ctx.$i18n.locale === 'zh' ? 'yyyy-MM-dd  HH时' : 'yyyy-MM-dd  HHH'),
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("span", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (quickChangeForecastDate('next'))),
                      style: {"rotate":"90deg"},
                      class: "icon iconfont icon-jiantouxia"
                    })
                  ], 64))
                : (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    modelValue: currentAdjustDataDateList.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentAdjustDataDateList).value = $event)),
                    multiple: "",
                    onChange: changeAdjustForecastDate,
                    size: "small",
                    teleported: "",
                    placement: "bottom-start",
                    "popper-options": { modifiers: [{ name: 'flip', options: { fallbackPlacements: [] } }] },
                    "collapse-tags": "",
                    "multiple-limit": 6
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataDateList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: _unref(timeToString)(new Date(item), _ctx.$i18n.locale === 'zh' ? 'yyyy-MM-dd  HH时' : 'yyyy-MM-dd  HHH'),
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
            ], 2),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mode-compare-control-panel-merge-item", { 'mode-compare-control-panel-merge-item-active': linearFillColor.value }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (switchVisualEffect()))
                    }, _toDisplayString(_unref(t)('linearFillColor')), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mode-compare-control-panel-merge-item", { 'mode-compare-control-panel-merge-item-active': maskDisplay.value }]),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (switchMaskDisplay()))
                    }, _toDisplayString(_unref(t)('mask')), 3)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mode-compare-control-panel-merge-item", { 'mode-compare-control-panel-merge-item-active': gridData.value }]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (switchGridData()))
                    }, _toDisplayString(_unref(t)('gridData')), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mode-compare-control-panel-merge-item", { 'mode-compare-control-panel-merge-item-active': flowLineDisplay.value && windSelectLevel.value !== undefined }]),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (switchFlowLineDisplay()))
                    }, _toDisplayString(_unref(t)('seaLevelPressure')), 3)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mode-compare-control-panel-merge-item", seaLevelPressure.value ? 'mode-compare-control-panel-merge-item-active' : '']),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (switchSeaLevelPressure()))
                    }, _toDisplayString(_unref(t)('flowLine')), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["mode-compare-control-panel-merge-item", { 'mode-compare-control-panel-merge-item-active': gridWind.value && windSelectLevel.value !== undefined }]),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (switchGridWind()))
                    }, _toDisplayString(_unref(t)('gridWind')), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('GPH')), 1),
                      _createElementVNode("div", _hoisted_27, [
                        (heightSelectMode.value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(ModeForecast.levelOption, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["mode-compare-control-panel-select-item", heightSelectLevel.value === item ? 'mode-compare-control-panel-select-item-active' : '']),
                                onClick: ($event: any) => (changeSelectLevel('height', item))
                              }, _toDisplayString(item), 11, _hoisted_28))
                            }), 256))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(t)('undefined')), 1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(windSelectTitle.value), 1),
                      _createElementVNode("div", _hoisted_32, [
                        (windSelectMode.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (selectElement.value === _unref(Enum_ForecastElement).L_WVFL)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["mode-compare-control-panel-select-item", windSelectLevel.value === -9999 ? 'mode-compare-control-panel-select-item-active' : '']),
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (changeSelectLevel('wind', -9999)))
                                  }, " 水汽通量矢量 ", 2))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentWindLevelOption.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["mode-compare-control-panel-select-item", windSelectLevel.value === item ? 'mode-compare-control-panel-select-item-active' : '']),
                                  onClick: ($event: any) => (changeSelectLevel('wind', item))
                                }, _toDisplayString(item === 0 ? "10m" + _unref(t)('wind') : item), 11, _hoisted_33))
                              }), 256))
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(t)('undefined')), 1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)('dateInterval')), 1),
                  _createVNode(_component_el_select, {
                    modelValue: forecastDateInterval.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((forecastDateInterval).value = $event)),
                    onChange: changeForecastDateInterval,
                    class: "mode-compare-control-panel-interval-select custo-el-input custo-el-select",
                    size: "small",
                    teleported: "",
                    placement: "bottom-start",
                    "popper-options": { modifiers: [{ name: 'flip', options: { fallbackPlacements: [] } }] }
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forecastDateIntervalOption.value, (interval) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: interval + _unref(t)('hour'),
                          value: interval
                        }, null, 8, ["label", "value"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(t)('forecastTime')), 1),
                  _createVNode(_component_el_scrollbar, {
                    ref_key: "fcstOptionScrollBarRef",
                    ref: fcstOptionScrollBarRef
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        (selectElement.value && ModeForecast.judgeTotalPre(selectElement.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forecastDateScaleOption.value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    onClick: ($event: any) => (changeTotalDataDate('start', item)),
                                    class: _normalizeClass([totalForecastDateScale.value[0] === item ? 'mode-compare-control-panel-select-item-active' : '', "mode-compare-control-panel-select-item mode-compare-control-panel-date-item"])
                                  }, _toDisplayString((item < 10 ? "00" : (item < 100 ? "0" : "")) + item), 11, _hoisted_41))
                                }), 256))
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forecastDateScaleOption.value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    onClick: ($event: any) => (changeTotalDataDate('end', item)),
                                    class: _normalizeClass([totalForecastDateScale.value[1] === item ? 'mode-compare-control-panel-select-item-active' : '', "mode-compare-control-panel-select-item mode-compare-control-panel-date-item"])
                                  }, _toDisplayString((item < 10 ? "00" : (item < 100 ? "0" : "")) + item), 11, _hoisted_43))
                                }), 256))
                              ])
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(forecastDateScaleOption.value?.filter((item) => item % forecastDateInterval.value === 0), (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["mode-compare-control-panel-select-item mode-compare-control-panel-date-item", {
                        'mode-compare-control-panel-select-item-active': forecastDateScale.value === item,
                        'mode-compare-control-panel-select-item-disabled': displaySelect.value === 'multiTime' &&
                          index > (forecastDateScaleOption.value?.filter((item) => item % forecastDateInterval.value === 0).length - multiTimeLength.value)
                      }]),
                                onClick: ($event: any) => (changeDataDate(item, index))
                              }, _toDisplayString((item < 10 ? "00" : (item < 100 ? "0" : "")) + item + "  |  " + _unref(timeToString)(_unref(DateAdd)("h",
                        item, displaySelect.value !== 'adjust' ? currentDataDate.value : currentAdjustDataDateList.value[0]), "MM-dd HH")), 11, _hoisted_44))
                            }), 256))
                      ])
                    ]),
                    _: 1
                  }, 512)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["config"])
    ]),
    _createVNode(ModeCompare, {
      ref_key: "ModeCompareRef",
      ref: ModeCompareRef,
      linearFillColor: linearFillColor.value,
      heightSelectLevel: heightSelectLevel.value,
      gridData: gridData.value,
      gridWind: gridWind.value,
      flowLineDisplay: flowLineDisplay.value,
      maskDisplay: maskDisplay.value
    }, null, 8, ["linearFillColor", "heightSelectLevel", "gridData", "gridWind", "flowLineDisplay", "maskDisplay"]),
    _createVNode(Container, {
      config: ModeForecast.SingleDrawInfoContainer,
      class: "single-draw-info-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          (displaySelect.value === 'single')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(ModeForecast.getModeLabel(modeSelectList.value[0]) +
        ` -- ${_unref(timeToString)(new Date(currentDataDate.value), "yyyy-MM-dd HH:00")} + ` +
        (forecastDateScale.value < 10 ? "00" : (forecastDateScale.value < 100 ? "0" : "")) + `${forecastDateScale.value}H`), 1)
              ], 64))
            : _createCommentVNode("", true),
          (ModeForecast.processMaximumEle.includes(selectElement.value ?? _unref(Enum_ForecastElement).未知))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(timeToString)(new Date(currentDataDate.value), "(ddHH-") + _unref(timeToString)(_unref(DateAdd)("h", forecastDateScale.value, new
              Date(currentDataDate.value)), "ddHH)")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_unref(timeToString)(_unref(DateAdd)("h", forecastDateScale.value, new Date(currentDataDate.value)), "(ddHH)")), 1)
              ], 64))
        ])
      ]),
      _: 1
    }, 8, ["config"]),
    _createVNode(Container, {
      config: ModeForecast.SingleDrawTexContainer,
      class: "single-draw-tex-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          (selectElement.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString((sliceLayerCurrentHeight.value ? `${sliceLayerCurrentHeight.value}hPa` : "") +
        `${ModeForecast.getEleCHN(selectElement.value)}(${currentLayerTag.value === "tex" ? (_unref(t)('shadow') +
          (isolineDisplay.value ? "/" + _unref(t)('isoline') : "") + (gridData.value ? "/" + _unref(t)('gridData') : "")) : _unref(t)('isoline')})`), 1)
              ], 64))
            : _createCommentVNode("", true),
          (heightSelectLevel.value && heightSelectMode.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString((selectElement.value ? "，" : "") +
          `${heightSelectLevel.value}hPa${_unref(t)('geopotentialHeightIsoline')}(${ModeForecast.getModeLabel(heightSelectMode.value)
          })`), 1)
              ], 64))
            : _createCommentVNode("", true),
          (seaLevelPressure.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(((selectElement.value || (heightSelectLevel.value && heightSelectMode.value)) ? "，" : "") +
          `${_unref(t)('seaLevelPressureIsoline')}(${ModeForecast.getModeLabel(heightSelectMode.value)})`), 1)
              ], 64))
            : _createCommentVNode("", true),
          (windSelectMode.value && windSelectLevel.value !== undefined && (gridWind.value || flowLineDisplay.value))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(((selectElement.value || (heightSelectLevel.value && heightSelectMode.value) || seaLevelPressure.value) ? "，" : "") +
          `${ModeForecast.getWindArrowName(windSelectLevel.value, windSelectMode.value, gridWind.value, flowLineDisplay.value)}`), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["config"]),
    _createVNode(Container, {
      config: ModeForecast.ModeSliceHeightPanelContainer,
      class: "mode-slice-height-panel-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sliceLayerHeightOption.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["height-item", { 'height-item-active': (highLevelSlice.value && highLevelSliceHeight.value.includes(item)) || (!highLevelSlice.value && item === sliceLayerCurrentHeight.value) }]),
              onClick: ($event: any) => (changeSliceLayerHeight(item))
            }, _toDisplayString(item), 11, _hoisted_48))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["config"]),
    _createVNode(Container, {
      config: ModeForecast.WPRInfoPanelContainer,
      class: "single-draw-info-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, "风廓线雷达: " + _toDisplayString(wprDate.value), 1)
      ]),
      _: 1
    }, 8, ["config"]),
    _createVNode(ECMWFImagePanel, {
      config: ModeForecast.ECMFConfig
    }, null, 8, ["config"]),
    _createVNode(HighLevelSlicePanel),
    _cache[14] || (_cache[14] = _createElementVNode("div", { id: "pro-Make-view-content-inner-box" }, null, -1))
  ], 64))
}
}

})